

/*
// Be sure to include popper.min.js before Bootstrap’s JavaScript
import * as Popper from "@popperjs/core";
import { createPopper } from '@popperjs/core';
window.Popper = Popper;
window.createPopper = createPopper;
*/


//import * as pdfjs from 'pdfjs-dist/build/pdf.mjs';
//import './node_modules/pdfjs-dist/build/pdf.mjs';
//import { getDocument } from "./node_modules/pdfjs-dist/legacy/build/pdf.mjs";

import DrDocWeb from "./drdocweb.js";
import "./drdocweb-bs.js";
import Dataset from "./dataset.js";
import Store from "./drdocstore.js";
import DrDocConfig from "./drdocconfig.js";
import Node from "./drdocnode.js";

import Split from 'split.js';
import uniqolor from 'uniqolor';


window.Store = Store;
window.Node = Node;
window.uniqolor = uniqolor;

if (window.DrDoc !== undefined) {
    console.warn('Lib Duplicate: DrDoc');
    //return;
}

export default function DrDoc() {

};

// DrDoc wird global in DrDoc.Init() gesetzt
// window.DrDoc = DrDoc;

window.Split = Split;

// --
// Dr.DOC
// Requires: DrDocWeb, Node, Store

// --
DrDoc.GetMaskNodeId = function (sourceElement, archiveName, newWindow) {
    if (newWindow === true) {
        return 'system/mask-info';
    }

    var elem = null;
    if (elem == undefined || elem == null)
        elem = Node.GetElement('system/mask-searchfields|content', sourceElement);
    // Modal VOR den anderen
    if (elem == undefined || elem == null)
        elem = Node.GetElement('system/mask|content', sourceElement);
    if (elem == undefined || elem == null)
        elem = Node.GetElement('system/mask-info|content', sourceElement);
    if (elem == undefined || elem == null)
        elem = Node.GetElement('system/list|content|' + archiveName + '|dataset', sourceElement);
    if (elem == undefined || elem == null)
        elem = Node.GetElement('system/list-kanban|content|' + archiveName + '|dataset', sourceElement);

    //elem = 'system/mask|content';
    if (elem == undefined || elem == null) {
        //return 'system/list|content|' + archiveName + '|dataset';
        return 'system/mask|content';
    }
    else
        return elem;
};
DrDoc.GetListNodeId = function (sourceElement, archiveName, newWindow) {
    if (newWindow === true) {
        return 'system/list-info';
    }

    var elem = null;
    if (elem == undefined || elem == null)
        elem = Node.GetElement('system/list|content|' + archiveName, sourceElement);
    if (elem == undefined || elem == null)
        elem = Node.GetElement('system/list-info|content', sourceElement);
    // Kanban Dr.DOC Theme
    if (elem == undefined || elem == null)
        elem = Node.GetElement('system/list-kanban|content|' + archiveName, sourceElement);
    if (elem == undefined || elem == null)
        elem = Node.GetElement('system/list-kanban2|content|' + archiveName, sourceElement);
    // Kanban Default Theme
    if (elem == undefined || elem == null)
        elem = Node.GetElement('system/list-kanban2|content', sourceElement);

    if (elem == undefined || elem == null) {
        //return 'system/list|content|' + archiveName;
        return 'system/list-info|content';
    }
    else
        return elem;
};
/*DrDoc.GetListTemplateName = function (sourceElement) {
    // system/list | content | wfmain | TODOLISTE | 19735
    let searchTemplateName = '_DEFAULT_';
    //let nodeId = rowElem;
    let nodeIdOrig = Node.GetNodeId(sourceElement);
    if (!DrDocWeb.IsNullOrEmpty(nodeIdOrig)) {
        let nodeIdSegments = nodeIdOrig.split('|');
        if (nodeIdSegments.length > 3) {
            searchTemplateName = nodeIdSegments[3];
        }
        //let nodeId = nodeIdSegments.join('|');
        //console.log('DrDoc.UpdateDatasetRow', nodeIdOrig, " => ", nodeId);
    }
    return searchTemplateName;
};*/
DrDoc.GetListDatasetID = function (sourceElement) {
    var nodeName_selected = Node.GetNodeId(sourceElement);
    var nodeNameSegments_selected = nodeName_selected.split('|');
    var documentId_selected = nodeNameSegments_selected[nodeNameSegments_selected.length - 1];
    return documentId_selected;
};
DrDoc.GetSearchTemplate = function (sourceElement, archiveName) {
    let selectedSearchTemplate = DrDocWeb.kvp_get(sourceElement, 'searchresult', 'value', null, null, true);
    if (selectedSearchTemplate != undefined && selectedSearchTemplate != null && !DrDocWeb.IsNullOrEmpty(selectedSearchTemplate['searchtemplate'])) {
        //console.info('DrDoc.GetSearchTemplate: selectedSearchTemplate kvp 1 strict true: ', selectedSearchTemplate);
        DrDoc.configDevice.set('view/list/' + archiveName + '/selected-searchtemplate', selectedSearchTemplate['searchtemplate']);
        return selectedSearchTemplate['searchtemplate'];
    }

    /*selectedSearchTemplate = DrDocWeb.kvp_get(sourceElement, 'searchtemplate', 'value', null, null, false);
    if (selectedSearchTemplate != undefined && selectedSearchTemplate != null && !DrDocWeb.IsNullOrEmpty(selectedSearchTemplate['searchtemplate']))
    {
        console.info('DrDoc.GetSearchTemplate: selectedSearchTemplate kvp 2 strict false: ', selectedSearchTemplate);
        DrDoc.configDevice.set('view/list/' + archiveName + '/selected-searchtemplate', selectedSearchTemplate['searchtemplate']);
        return selectedSearchTemplate['searchtemplate'];
    }*/

    let configSearchTemplate = DrDoc.configDevice.get('view/list/' + archiveName + '/selected-searchtemplate', '_DEFAULT_');
    //console.info('DrDoc.GetSearchTemplate: selectedSearchTemplate config: ', configSearchTemplate);
    return configSearchTemplate;
};
DrDoc.GetSearchFieldSelection = function (sourceElement, archiveName) {
    // verwendete Feld Auswahlen laden aus DatasetListContainerWebNode
    //let selectedSearchTemplate2 = DrDocWeb.kvp_get(sourceElement, 'selection', 'value', null, null, true);
    //let selectedSearchTemplate3 = DrDocWeb.kvp_get(sourceElement, 'searchtemplate', 'value', null, null, true);
    //let selectedSearchTemplate4 = DrDocWeb.kvp_get(sourceElement, 'recursive-query', 'value', null, null, true);
    let selectedSearchTemplate = DrDocWeb.kvp_get(sourceElement, 'searchresult', 'value', null, null, true);
    //console.log('DrDoc.GetSearchFieldSelection: ', selectedSearchTemplate, ' / ', selectedSearchTemplate2, ' / ', selectedSearchTemplate3, ' / ', selectedSearchTemplate4);
    if (selectedSearchTemplate != undefined && selectedSearchTemplate != null && !DrDocWeb.IsNullOrEmpty(selectedSearchTemplate['fieldselection']))
        return selectedSearchTemplate['fieldselection'];
    else
        return '';
};
// DOM Node
DrDoc.GetTableRowElementByIDInternal = function (sourceElement, archiveName, byIdGetRow, documentIdOrig) {
    if (typeof sourceElement === 'string')
        sourceElement = Node.GetElement(sourceElement, null);
    let elem = undefined;
    if (elem == undefined || elem == null)
        elem = Node.GetElement('system/list-default|content', sourceElement);
    //if (elem == undefined)
    //    elem = Node.GetElement('system/list-2|content');

    let selectedSearchTemplate = DrDoc.GetSearchTemplate(sourceElement, archiveName);

    let documentId = documentIdOrig;
    if (byIdGetRow) {
        if (!DrDocWeb.IsNullOrEmpty(documentId) || documentId != 0) // && documentId.length > 0)
            documentId = '|' + documentId;
        else
            console.warn('DrDoc.GetTableRowElementByIDInternal: es wurde keine "documentId" übergeben - List Element nicht gefunden!', sourceElement, archiveName, documentIdOrig, '"' + selectedSearchTemplate + '"');
    }
    else
        documentId = '';

    // list-info.content ist DatasetListContainerWebNode
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list-info|content|' + archiveName + documentId, sourceElement);
    if (elem == undefined || elem == null)
        elem = Node.GetElement('system/list-info|content' + documentId, sourceElement);
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list-info|content|' + archiveName, sourceElement);
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list-info|content', sourceElement);

    // list-thes.content ist DatasetListContainerWebNode
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list-thes|content|' + archiveName + documentId, sourceElement);
    if (elem == undefined || elem == null)
        elem = Node.GetElement('system/list-thes|content' + documentId, sourceElement);
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list-thes|content|' + archiveName, sourceElement);
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list-thes|content', sourceElement);

    // list-thes.content ist MultiArchiveDatasetListContainerWebNode
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list|content|' + archiveName + '|zusatzinfo', sourceElement);
    if ((elem == undefined || elem == null) && !DrDocWeb.IsNullOrEmpty(selectedSearchTemplate))
        elem = Node.GetElement('system/list|content|' + archiveName + '|' + selectedSearchTemplate + documentId, sourceElement);
    if (elem == undefined || elem == null)
        elem = Node.GetElement('system/list|content|' + archiveName + '|_DEFAULT_' + documentId, sourceElement);
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list|content|' + archiveName, sourceElement);
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list|content', sourceElement);

    if ((elem == undefined || elem == null) && !DrDocWeb.IsNullOrEmpty(selectedSearchTemplate)) {
        elem = Node.GetElement('system/list-kanban|content|' + archiveName + '|' + selectedSearchTemplate + documentId, sourceElement);
        //console.log('DrDoc.GetTableRowElementByIDInternal: ', 'system/list-kanban|content|' + archiveName + '|' + selectedSearchTemplate + documentId, elem);
    }
    if (elem == undefined || elem == null)
        elem = Node.GetElement('system/list-kanban|content' + documentId, sourceElement);
    if (elem == undefined || elem == null)
        elem = Node.GetElement('system/list-kanban2|content' + documentId, sourceElement);

    //if (elem == undefined)
    //    elem = Node.GetElement('system/list|content|'+archiveName + '|_DEFAULT_');
    //if (elem == undefined || elem == null)
    //    elem = Node.GetElement('system/list|dataset-list-content', sourceElement);
    //if (elem == undefined)
    //    elem = Node.GetElement('system/list-2|content');

    if (elem === undefined || elem === null) {
        if (sourceElement == undefined || sourceElement == null) {
            console.warn('DrDoc.GetTableRowElementByIDInternal: List Element nicht gefunden! / archiveName: ', archiveName, ' / byIdGetRow: ', byIdGetRow, ' / documentId: ', documentId, ' / documentIdOrig: ', documentIdOrig, ' / selectedSearchTemplate: "' + selectedSearchTemplate + '" / sourceElement: ', sourceElement);
            return undefined;
        }
        else {
            // Nochmal ohne source element probieren
            return DrDoc.GetTableRowElementByIDInternal(undefined, archiveName, byIdGetRow, documentIdOrig); //, isZusatzInfo);
        }
    }
    //console.log('DrDoc.GetTableRowElementByIDInternal', elem, archiveName, byIdGetRow, documentIdOrig, '"' + selectedSearchTemplate + '"');
    return elem;
};

DrDoc.GetDataset = function (sourceElement, archiveName, documentIdField, documentId, mode, ignoreUnloadEvent) {
    let nodeId = DrDoc.GetMaskNodeId(sourceElement, archiveName);

    //if (typeof node === 'string')
    //{
    //    if (mode !== undefined && mode.length > 0)
    //        nodeId = 'system/mask-' + mode + '|content';
    //    else
    //        nodeId = 'system/mask|content';
    //}
    /*if (DrDocWeb.IsMobile())
    {
        nodeId = null;
    }*/
    return window.Node.LoadComponent({
        title: 'Datensatz im Archiv ' + DrDoc.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            id_field: (documentIdField === undefined || documentIdField === null ? '' : documentIdField),
            id: (documentId === undefined || documentId === null ? '' : documentId),
            mode: mode,
            thes: false //true
        },
        ignoreUnloadEvent: ignoreUnloadEvent
    });
    /*.then(data => {
        //console.log('GetDataset (=> geladen): ', archiveName, documentId, mode, sourceElement);
        // Wenn der Datensatz geladen wurde, Modal wieder schließen.
        //let res = DrDocWeb.ModalClose(sourceElement);
        //console.log('Modal close', res);
        //setTimeout(function(){ 
        //let res = DrDocWeb.ModalClose(sourceElement);
        //console.log('Modal close', res);})

    }); //.then(DrDoc.MaskLoadFirstTab);*/
};
DrDoc.ButtonFn = function (sourceElement, archiveName, documentIdField, documentId, fieldName, tableRow, mode, fnStr, hasDocument) {
    // Immer|Kontext,123,Rechendef Ausf.;Parameter
    var fnArgs = fnStr.split(';');
    if (fnArgs == null || fnArgs == undefined || fnArgs.length < 3) {
        console.error('DrDoc.ButtonFn: Bad Buttonfunction', fnStr);
        DrDocWeb.Modal('ButtonFn', `Bad Function "${fnStr}".`);
        return;
    }

    var fnExecContext = fnArgs[0];
    var fnNr = fnArgs[1];
    var fnName = fnArgs[2];
    var fnValue = fnArgs[3];

    //let form = DrDocWeb.GetElement(sourceElement, 'form');
    // form[fnValue].value

    let postData = {};
    let form = Node.ParseFormData(sourceElement, null, postData, true, false);
    console.log('ButtonFn', sourceElement, archiveName, documentIdField, documentId, fieldName, tableRow, mode, fnStr, ' / Form: ', form, postData, postData[fnValue]);

    switch (fnNr) {
        // 391: Feld drucken
        // 400: Vorblättern
        // 401: Zurückblättern
        // 306: Datenübergabe
        // 308: drucken
        // 126: DS kopieren
        // 403: DS löschen
        // 515: ersetzen
        // 405: Dokument anzeigen
        // 180: Export Ascii
        // 541: Dok. exportieren
        // 402: Speichern
        // 230: Abbrechen
        // 182: Import ASCII
        // 189: Dokument neu
        // 724: Auto. Thes. ausführen
        // 725: DS aktualisieren

        // 55556: Kenntnisnahme

        // 2200: Kalenderneueingabe
        // 3200: Kalenderexport

        case '405':
            // Btn. Dok. anzeigen
            //DrDoc.MaskShowDocument(sourceElement, archiveName, documentId);
            DrDoc.WfGetDataset(sourceElement, true, true);
            break;

        case '332':
        case '434':
            // E-Mail
            DrDoc.ButtonFnEmail(sourceElement, archiveName, documentIdField, documentId, postData[fnValue], hasDocument);
            break;

        case '445':
            // Tel wählen
            window.open('tel:' + postData[fnValue]);
            break;

        case '606':
            // Website
            window.open(postData[fnValue].replaceAll('|', '; '));
            break;

        case '723':
            // Rechendef ausführen
            DrDoc.GetDataset(sourceElement, archiveName, documentIdField, documentId, 'calc', true);
            break;

        default:
            DrDocWeb.Modal('ButtonFn', `Function "${fnName}", Nr. "${fnNr}" not Implemented yet!`);
            break;

    }
};

DrDoc.ButtonFnPrintGen = function (_sourceElement, archiveName, documentIdField, documentId, hasDocument) {
    let elemId = 'elem-' + DrDocWeb.RandomChars(12); //sourceElement.getAttribute('id');

    let retHtml = ``;

    hasDocument = !DrDocWeb.IsNullOrEmpty(documentId) && +documentId > 0 && hasDocument === true;

    // Dokument aus Metadaten generieren und archivieren
    // Dokument aus Metadaten als Anhang per E-Mail versenden

    retHtml += `

        Für ZUGFeRD PDF + XML anklicken.<br/>

        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--format_pdf" value="1" ${(hasDocument ? '' : 'checked')} />
            <label class="form-check-label d-block" for="${elemId}--format_pdf">PDF</label>
        </div>

        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--format_xml" value="1" ${(hasDocument ? '' : 'checked')} />
            <label class="form-check-label d-block" for="${elemId}--format_xml">XML</label>
        </div>

        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--file_html" value="1" />
            <label class="form-check-label d-block" for="${elemId}--file_html">File HTML veröffentlichen</label>
        </div>
        
        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--file_doc" value="1" />
            <label class="form-check-label d-block" for="${elemId}--file_doc">File Dokument veröffentlichen</label>
        </div>

        <br /><br />

        <button type="button" class="btn btn-success btn-sm" onclick="window['_dd_btn_fn_action_${elemId}'](this);">
            Aktionen ausführen (z.B. versenden) &nbsp;&nbsp;&nbsp;<i class="bi bi-receipt"></i>
        </button>
        `;


    retHtml += `
        `;

    console.log('Generate Doc Button 1: ', _sourceElement, archiveName);

    let modal = DrDocWeb.Modal('Dokument generieren', retHtml);

    window['_dd_btn_fn_action_' + elemId] = function (sourceElement) //, archiveName)
    {

        console.log('Generate Doc Button 2: ', sourceElement, archiveName);

        return window.Node.LoadComponent({
            title: 'Dokument generieren (Vorschau)',
            sourceElement: sourceElement,
            targetElement: 'system/rec-out|content|archive-' + archiveName,
            view: 'None',
            //newWindow: true,
            getData: {
                archive: archiveName,
                id_field: (!DrDocWeb.IsNullOrEmpty(documentIdField) ? documentIdField : DrDoc.ID_FIELD),
                id: documentId,
                archive_doc: true,
                email: false,
                email_att: false,
                email_value: '',
                file_html: document.getElementById(elemId + '--file_html').checked,
                file_doc: document.getElementById(elemId + '--file_doc').checked,
                format_pdf: document.getElementById(elemId + '--format_pdf').checked,
                format_xml: document.getElementById(elemId + '--format_xml').checked,
                log: true,
                //email_field: value, //'c_email',
                //name_field: 'c_name'
                //__cookie: document.cookie,
            },
            // postData: { }
        }).then(function (win) {
            modal.hide();
            /*setTimeout(function(){
                DrDoc.GetDataset(sourceElement, archiveName, documentIdField, documentId, 'get', true);
            }, 1000);*/
            setTimeout(function () {
                DrDoc.GetDataset(_sourceElement, archiveName, documentIdField, documentId, 'get', true);
            }, 3500);
        });
    };
};

DrDoc.ButtonFnEmail = function (_sourceElement, archiveName, documentIdField, documentId, value, hasDocument, nodeIdPath) {

    if (DrDocWeb.IsNullOrEmpty(nodeIdPath))
        nodeIdPath = 'system/rec-out';

    let elemId = 'elem-' + DrDocWeb.RandomChars(12);
    let retHtml = ``;

    hasDocument = !DrDocWeb.IsNullOrEmpty(documentId) && +documentId > 0 && hasDocument === true;

    // Dokument aus Metadaten generieren und archivieren
    // Dokument aus Metadaten als Anhang per E-Mail versenden

    retHtml += `
<button type="button" class="btn btn-primary btn-sm" onclick="window.open('mailto:${value}');">E-Mail verfassen (lokale App)</button>

<br />
<hr>
<br />

<form onsubmit="window['_dd_btn_fn_action_${elemId}'](this); return false;">

<label class="form-label">Empfänger E-Mail-Adresse:
<input type="email" class="form-control" placeholder="Empfänger E-Mail &quot;${value}&quot; überschreiben" id="${elemId}--email-address" value="${value}">
</label>

<br /><br />

        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--email" value="1" checked />
            <label class="form-check-label d-block" for="${elemId}--email"><b>E-Mail versenden</b></label>
        </div>
        <div class="ms-4">
        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--email_att" value="1" checked />
            <label class="form-check-label d-block" for="${elemId}--email_att">Ein <b>Dokument als Anhang</b> per <b>E-Mail versenden</b></label>
        </div>
        </div>
        
<br />

        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--file_html" value="1" />
            <label class="form-check-label d-block" for="${elemId}--file_html">File HTML veröffentlichen</label>
        </div>
        
        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--file_doc" value="1" />
            <label class="form-check-label d-block" for="${elemId}--file_doc">File Dokument veröffentlichen</label>
        </div>

        <br /><br />

        <button type="submit" class="btn btn-success btn-sm">
            Aktionen ausführen (z.B. versenden) &nbsp;&nbsp;&nbsp;<i class="bi bi-receipt"></i>
        </button>
</form>
        `;


    retHtml += `
        `;

    console.log('Send Mail Button 1: ', _sourceElement, archiveName);

    let modal = DrDocWeb.Modal('E-Mail senden', retHtml);

    window['_dd_btn_fn_action_' + elemId] = function (sourceElement) //, archiveName)
    {
        let sendEmailAtt = document.getElementById(elemId + '--email_att').checked === true;

        console.log('Send Mail Button 2: ', sourceElement, archiveName);

        return window.Node.LoadComponent({
            title: 'E-Mail versenden (Vorschau)',
            sourceElement: sourceElement,
            //targetElement: 'system/rec-out|content|archive-' + archiveName,
            targetElement: nodeIdPath + '|content|archive-' + archiveName,
            view: 'None',
            //newWindow: true,
            getData: {
                archive: archiveName,
                id_field: (!DrDocWeb.IsNullOrEmpty(documentIdField) ? documentIdField : DrDoc.ID_FIELD),
                id: documentId,
                archive_doc: false,
                zugferd: false,
                email: document.getElementById(elemId + '--email').checked,
                email_value: document.getElementById(elemId + '--email-address').value,
                email_att: sendEmailAtt,
                file_html: document.getElementById(elemId + '--file_html').checked,
                file_doc: document.getElementById(elemId + '--file_doc').checked,
                log: true,
                //email_field: value, //'c_email',
                //name_field: 'c_name'
                //__cookie: document.cookie,
            },
            // postData: { }
        }).then(function (win) {
            modal.hide();

            // Fenster schließen, da existierender DS angezeigt werden soll

            if (win !== undefined)
                win.close();
            setTimeout(function () {
                DrDoc.MaskShowDocument(_sourceElement, archiveName, documentId);
            }, 500);
        });
    };
};


DrDoc.SignForm = function (_sourceElement, archiveName, documentIdField, documentId) {
    let elemId = 'elem-' + DrDocWeb.RandomChars(12);
    let retHtml = ``;
    let hasDocument = !DrDocWeb.IsNullOrEmpty(documentId) && +documentId > 0;

    //DrDoc.MaskGetDocumentUrlByField(archiveName, documentIdField, documentId, page, sign, sign_create, sign_pos, sign_text_rel, sign_align)

    retHtml += `

        <div class="form-check form-switch">
            <input type="checkbox" class="form-check-input" id="${elemId}--new" value="1" />
            <label class="form-check-label d-block" for="${elemId}--new">Dieses Dokument als Vorlage verwenden und neues Dokument erstellen.</label>
        </div>
        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--preset" value="" />
            <label class="form-label d-block" for="${elemId}--preset">Feldvorbelegung</label>
        </div>
        
        <br /><br />

        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--pos_x" value="10%" />
            <label class="form-label d-block" for="${elemId}--pos_x">Position X</label>
        </div>
        
        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--pos_y" value="80%" />
            <label class="form-label d-block" for="${elemId}--pos_y">Position Y</label>
        </div>
        
        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--pos_w" value="55%" />
            <label class="form-label d-block" for="${elemId}--pos_w">Breite</label>
        </div>
        
        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--pos_h" value="80pt" />
            <label class="form-label d-block" for="${elemId}--pos_h">Höhe</label>
        </div>

        <br /><br />

        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--sign_text_rel" value="Unterschrift;Unterschrift XYZ" />
            <label class="form-label d-block" for="${elemId}--sign_text_rel">Referenz Text</label>
        </div>

        <div class="form-check form-switch">
            <input type="text" class="form-control" id="${elemId}--sign_align" value="top" />
            <label class="form-label d-block" for="${elemId}--sign_align">Align</label>
        </div>

        <br /><br />

        <button type="button" class="btn btn-success btn-sm" onclick="window['_dd_action_${elemId}'](this);">
            Aktionen ausführen&nbsp;&nbsp;&nbsp;<i class="bi bi-receipt"></i>
        </button>

            <input type="text" class="form-control" id="${elemId}--result" value="" />
        `;

    retHtml += `
        `;

    let modal = DrDocWeb.Modal('Signatur Link erstellen', retHtml);

    window['_dd_action_' + elemId] = function (sourceElement) //, archiveName)
    {
        let url = DrDoc.MaskGetDocumentUrlByField(archiveName, documentIdField, documentId,
            0, true,
            document.getElementById(elemId + '--new').checked,
            document.getElementById(elemId + '--preset').value,
            document.getElementById(elemId + '--pos_x').value + ';' + document.getElementById(elemId + '--pos_y').value + ';' + document.getElementById(elemId + '--pos_w').value + ';' + document.getElementById(elemId + '--pos_h').value,
            document.getElementById(elemId + '--sign_text_rel').value, document.getElementById(elemId + '--sign_align').value);

        document.getElementById(elemId + '--result').value = url;

        console.log('Generate Sign Doc Link 2: ', sourceElement, archiveName, url);

    };
};

DrDoc.Thesaurus = function (sourceElement, archiveName, documentId, fieldName, tableRow, mode, append, thesNew, sourceElemIsTargetElem) {
    //let nodeId = 'system/list-thes|content';
    const newWindow = true;
    let nodeId = sourceElemIsTargetElem ? sourceElement : (newWindow == true ? 'system/list-thes|content' : DrDoc.GetTableNodeElement(sourceElement, archiveName));
    let field = DrDoc.GetField(archiveName, fieldName);

    /*let form = DrDocWeb.GetElement(sourceElement, 'form');
    if (form != null && form != undefined)
    {
        console.log('Thes.', form.beforeunload, form.onbeforeunload, form, sourceElement);
        sourceElement.beforeunload = undefined;
        form.beforeunload = undefined;
        window.onbeforeunload = undefined;
    }*/

    //let confirmMsg = true;
    //if (thesNew === undefined || thesNew === null)
    //    thesNew = false;
    //if (thesNew)

    return window.Node.LoadComponent({
        title: 'Thesaurus für das Feld ' + (field != null && field != undefined ? field.Label + ' (' + field.Name + ')' : fieldName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            mode: 'thes',
            //source_mode: mode,
            archive: archiveName,
            field: fieldName,
            row: (tableRow === undefined || tableRow === null ? 0 : tableRow),
            recursive: 'new',
            append: append,
            'tree-sub': true,
            //'thes-confirm': confirmMsg,
            'thes-new': (thesNew === undefined || thesNew === null ? false : thesNew),
            source: {
                //thes: true,
                mode: mode,
                archive: archiveName,
                field: fieldName,
                row: (tableRow === undefined || tableRow === null ? 0 : tableRow),
                //thes_id: (documentId === undefined || documentId === null ? '' : documentId),
                id: (documentId === undefined || documentId === null ? '' : documentId),
                append: append, //false
            }
        },
        ignoreUnloadEvent: true
    }).then(data => {
        //console.log('Thesaurus (=> geladen): ', archiveName, 'form-create', sourceElement, data);
        // Wenn der Datensatz geladen wurde, Modal wieder schließen.
        //DrDocWeb.ModalClose(sourceElement);
    }); //, DrDoc.ParentFormToObject(sourceElement));
};
DrDoc.ThesaurusDropdown = function (sourceElement, archiveName, documentId, fieldName) {
    if (sourceElement.options.length > 2)
        return;

    return window.Node.LoadComponent({
        title: 'Dropdown',
        sourceElement: sourceElement,
        targetElement: sourceElement,
        getData: {
            archive: archiveName,
            id: documentId,
            mode: 'thes-dropdown',
            thes: true,
            field: fieldName
        },
        ignoreLoadEvent: true
    });
};
DrDoc.Zusatzinfo = function (sourceElement, archiveName, documentId, fieldName, tableRow, mode, newWindow, sourceElemIsTargetElem) //, nodeId)
{
    //let nodeId = 'system/list-info|content';
    //if (DrDocWeb.IsNullOrEmpty(nodeId))
    let nodeId = sourceElemIsTargetElem ? sourceElement : (newWindow == true ? 'system/list-info' : 'system/list-info|content');
    //let nodeId = 'system/list-info|content';
    //let nodeId = newWindow == true ? 'system/list-info|content' : DrDoc.GetTableNodeElement(sourceElement, archiveName, true);
    //let nodeId = newWindow == true ? 'system/list-info|content' : DrDoc.GetTableNodeElement(sourceElement, '_zusatzinfo_');

    //let zusatzArchiveName = DrDoc.GetArchiveSession(archiveName).FieldSessions[fieldName].Zusatzinfo.ZusatzArchive.Archive.SimpleName;
    //DrDoc.configUser.set('view/selected-archive', zusatzArchiveName);
    //let nodeId = newWindow == true ? 'system/list-info|content' : DrDoc.GetTableNodeElement(sourceElement, zusatzArchiveName, true);
    //console.log('SOURCE ZUSATZ INFO', zusatzArchiveName, nodeId);

    let field = DrDoc.GetField(archiveName, fieldName);

    /*if (newWindow === true)
    {
        window.open()
    }
    else
    {
        DrDocWeb.ModalClose(sourceElement);
    }*/

    //DrDocWeb.ModalClose(sourceElement);

    var ret = Node.LoadComponent({
        title: 'Zusatzinfo für das Feld ' + (field != null && field != undefined ? field.Label + ' (' + field.Name + ')' : fieldName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            mode: 'info',
            //source_mode: mode,
            archive: archiveName,
            field: fieldName,
            row: (tableRow === undefined || tableRow === null ? 0 : tableRow),
            recursive: 'new',
            'tree-sub': true,
            source: {
                //thes: true,
                mode: mode,
                archive: archiveName,
                field: fieldName,
                row: (tableRow === undefined || tableRow === null ? 0 : tableRow),
                id: (documentId === undefined || documentId === null ? '' : documentId),
                append: false
            }
        },
        formFieldsOr: false,
        newWindow: newWindow
    }); //, DrDoc.ParentFormToObject(sourceElement));
    //DrDocWeb.ModalClose(sourceElement);
    return ret;
};
DrDoc.OnFormInit = function (sourceElement, archiveName, documentId, mode, lockedDocumentId) {
    var formHasChanged = false;
    //console.log('Init Mask ', sourceElement, archiveName, documentId, mode, lockedDocumentId, documentId === lockedDocumentId);

    // get, lock, 
    if (mode != 'form-searchfields' && mode != 'form-create' && mode != 'unlock-only') {

        var onFormInputChanged = function (e2) {
            //console.log('Input has changed!', formElem[0]);
            //formElem.attr('data-changed', 'true');
            formHasChanged = true;
        };

        //$(sourceElement).find('input').on('change', onFormInputChanged);
        //$(sourceElement).find('textarea').on('change', onFormInputChanged);
        //$(sourceElement).find('select').on('change', onFormInputChanged);

        sourceElement.querySelectorAll('input').forEach(function (elem, key) {
            elem.addEventListener('change', onFormInputChanged);
        });
        sourceElement.querySelectorAll('textarea').forEach(function (elem, key) {
            elem.addEventListener('change', onFormInputChanged);
        });
        sourceElement.querySelectorAll('select').forEach(function (elem, key) {
            elem.addEventListener('change', onFormInputChanged);
        });

        var beforeunloadFn = function (e2) {
            //DrDoc.CloseAllDocumentWnd();

            //console.log('..beforeunloadFn..'); //, this, e2);

            //console.log('Sollen die Änderungen in der Maske verworfen verden?', this);
            let ret = false;

            if (window.onbeforeunload == null || window.onbeforeunload == undefined) {
                //console.log('Nix machen, da Thes.!');
                if (this == window || this == document)
                    return undefined;
                else
                    return true;
            }
            // Wenn das Formular nicht geändert wurde und noch kein DS gelockt ist bzw. der geladene DS der gelockte ist,
            // dann abbrechen
            if (!formHasChanged && (lockedDocumentId <= 0 || lockedDocumentId == documentId)) {
                //console.log('Nix machen!');
                if (this == window || this == document)
                    return undefined;
                else
                    return true;
            }


            if (e2 != undefined && this == window || this == document) {
                console.log('beforeunloadFn - preventDefault');
                e2.preventDefault();
            }

            console.log('beforeunloadFn - Confirm Unlock', archiveName, documentId, mode, lockedDocumentId, documentId === lockedDocumentId);

            if (!formHasChanged) {
                //if (this == window)
                //	return 'Soll der von Ihnen gesperrte Datensatz freigegeben werden?';
                //ret = confirm('Soll der von Ihnen gesperrte Datensatz freigegeben werden?');
                ret = true;
                (e2 || window.event).returnValue = 'EVENT: Sollen der von Ihnen gesperrte Datensatz freigegeben werden?';
            }
            else {
                ret = confirm('Sollen die Änderungen im Datensatz verworfen und freigegeben verden?');
                (e2 || window.event).returnValue = 'EVENT: Sollen die Änderungen im Datensatz verworfen und freigegeben verden?';
            }

            if (ret) {
                console.log('beforeunloadFn - freigeben');
                if (sourceElement !== null && sourceElement !== undefined)
                    sourceElement.beforeunload = undefined;
                window.onbeforeunload = undefined;
                // Datensatz entsperren, wenn einer vorliegt
                if (lockedDocumentId >= 0) //{{$_this.ArchiveSession.HasLockedDataset}})
                {
                    DrDoc.UnlockOnlyDataset(sourceElement, archiveName, lockedDocumentId);
                }
                return true;
            }
            else {
                console.log('beforeunloadFn - bearbeiten');
                // Maske einblenden, damit man sie entsperren kann
                DrDoc.SetViewDataset(archiveName);
                return false;
            }
        };

        //window.addEventListener("beforeunload", beforeunloadFn);
        window.onbeforeunload = beforeunloadFn;

        if (sourceElement !== null && sourceElement !== undefined) {
            // wenn die Funktion "beforeunload" true zurück gibt, wird der neue Node geladen.
            sourceElement.beforeunload = beforeunloadFn;
        }
    }
};
DrDoc.OnFormSubmit = function (sourceElement, archiveName, documentId, mode) {
    //console.log('DrDoc.OnFormSubmit 1: ', mode, sourceElement);
    sourceElement = DrDocWeb.GetClosestForm(sourceElement);

    console.log('Form submitted..');
    if (!sourceElement.checkValidity()) {
        //event.preventDefault();
        //event.stopPropagation();
        sourceElement.classList.add('was-validated');

        console.warn('DrDoc.OnFormSubmit: ', 'Form has Invalid Field-Values!');
    }
    else {
        //event.preventDefault();
        //event.stopPropagation();
        sourceElement.classList.add('was-validated');

        //console.log('DrDoc.OnFormSubmit 2: ', sourceElement, archiveName, documentId, mode);

        if (mode == 'searchfields' || Node.GetElement('system/mask-searchfields|content') !== undefined) //mode == 'form-searchfields')
            return DrDoc.SearchFields(sourceElement, archiveName);
        else if (mode == 'create' || mode == 'form-create')
            return DrDoc.CreateDataset(sourceElement, archiveName);
        else if (mode == 'create-new')
            return DrDoc.CreateDataset(sourceElement, archiveName, true);
        else if (mode == 'create-form')
            return DrDoc.CreateDatasetForm(sourceElement, archiveName, null); // data, presetName, newWindow)
        else
            return DrDoc.SaveDataset(sourceElement, archiveName, documentId);
    }
};
DrDoc.CreateDatasetForm = function (sourceElement, archiveName, data, presetName, newWindow) {
    if (DrDocWeb.IsNullOrEmpty(archiveName)) {
        return DrDoc.GetSelectedArchive(function (archive) { return DrDoc.CreateDatasetForm(sourceElement, archive, data, presetName); });
    }
    archiveName = DrDoc.GetSimpleArchiveName(archiveName);

    let nodeId = DrDoc.GetMaskNodeId(sourceElement, archiveName, newWindow);

    var getObj = {
        archive: archiveName,
        mode: 'form-create',
        preset: (presetName === undefined || presetName === null ? '' : presetName)
    };

    if (sourceElement == null || sourceElement == undefined) {

        return window.Node.LoadComponent({
            title: 'Neuer Datensatz im Archiv ' + DrDoc.GetArchiveLabel(archiveName),
            sourceElement: null,
            targetElement: nodeId,
            getData: getObj,
            postData: data, //(data != null && data != undefined ? data : undefined)
            newWindow: newWindow
        });
    }

    DrDoc.SetViewDataset(archiveName);

    DrDoc.DatasetListUnselectItem(sourceElement, archiveName);

    //Node.SetFormFieldGetData(getObj, data);

    return window.Node.LoadComponent({
        title: 'Neuer Datensatz im Archiv ' + DrDoc.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: getObj,
        postData: data //(data != null && data != undefined ? data : undefined)
    }).then(data => {
        //console.log('CreateDatasetForm (=> geladen): ', archiveName, 'form-create', sourceElement);
        // Wenn der Datensatz geladen wurde, Modal wieder schließen.
    });
};
DrDoc.CreateDataset = function (sourceElement, archiveName, newWindow) {
    archiveName = DrDoc.GetSimpleArchiveName(archiveName);
    //let nodeId = 'system/mask-create|content';
    //if (DrDocWeb.IsNullOrEmpty(nodeId))
    //    nodeId = DrDoc.GetMaskNodeId(sourceElement, archiveName);
    let nodeId = DrDoc.GetMaskNodeId(sourceElement, archiveName, newWindow);

    DrDoc.SetViewDataset();

    return window.Node.LoadComponent({
        title: 'Neuer Datensatz im Archiv ' + DrDoc.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            mode: 'create'
        },
        //postData: { }
    }).then(data => {
        console.log('CreateDataset (=> geladen): ', archiveName, 'create', sourceElement, data);
        // Wenn der Datensatz geladen wurde, Modal wieder schließen.
        let res = DrDocWeb.ModalClose(sourceElement);
    });
};
DrDoc.SearchFieldsForm = function (sourceElement, archiveName) {
    if (DrDocWeb.IsNullOrEmpty(archiveName)) {
        return DrDoc.GetSelectedArchive(function (archive) { return DrDoc.SearchFieldsForm(sourceElement, archive); });
    }
    archiveName = DrDoc.GetSimpleArchiveName(archiveName);

    let nodeId = 'system/mask-searchfields|content';
    //let nodeId = 'system/mask-searchfields|content|' + archiveName;

    //DrDocWeb.ModalClose(sourceElement);

    DrDoc.SetViewDataset();

    return window.Node.LoadComponent({
        title: 'Feldsuche im Archiv ' + DrDoc.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            view: 'Search',
            archive: archiveName,
            mode: 'form-searchfields'
        }
    });
    /*.then(data => {
        //console.log('SearchFieldsForm (=> geladen): ', archiveName, 'form-searchfields', sourceElement);
        // Wenn der Datensatz geladen wurde, Modal wieder schließen.
        //let res = DrDocWeb.ModalClose(sourceElement);
    });*/
};
DrDoc.SearchFields = function (sourceElement, archiveName, data, newWindow) //, recursiveParam)
{
    archiveName = DrDoc.GetSimpleArchiveName(archiveName);
    let getObj = {
        archive: archiveName,
        mode: 'searchfields',
        //recursive: (recursiveParam === undefined || recursiveParam === null ? 'new' : recursiveParam)
    };

    // Feldsuche als GET
    //let postObj = null;
    Node.SetFormFieldGetData(getObj, data);

    // Feldsuche als POST
    //let postObj = data;

    if (sourceElement)
        DrDocWeb.ModalClose(sourceElement);
    DrDoc.SetViewList();
    return window.Node.LoadComponent({
        title: 'Feldsuche im Archiv ' + DrDoc.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: DrDoc.GetListNodeId(sourceElement, archiveName, newWindow),
        getData: getObj,
        postData: (data == undefined || data == null ? undefined : {}), // Daten aus Form verwenden, wenn "data" leer ist
        writeToGetData: true,
        formFieldsOr: true,
        newWindow: newWindow,
        nav: 'push',
    });
    /*.then(data => {
        //console.log('SearchFields (=> geladen): ', archiveName, 'searchfields', sourceElement);
        // Wenn der Datensatz geladen wurde, Modal wieder schließen.
    });*/
};
DrDoc.SearchFieldsInfo = function (sourceElement, archiveName, data, newWindow) //, recursiveParam)
{
    archiveName = DrDoc.GetSimpleArchiveName(archiveName);
    // newWindow == null || newWindow == undefined ||
    let nodeId = newWindow == true || sourceElement == undefined || sourceElement == null ? 'system/list-info' : DrDoc.GetTableNodeElement(sourceElement, archiveName);

    let getObj = {
        archive: archiveName,
        mode: 'searchfields',
        recursive: 'new',
        'tree-sub': true,
        nav: 'push',
    };

    //Node.SetFormFieldGetData(getObj, data);

    return window.Node.LoadComponent({
        title: 'Feldsuche im Archiv ' + DrDoc.GetArchiveLabel(archiveName) + '',
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: getObj,
        postData: data,
        formFieldsOr: true,
        newWindow: newWindow,
    });
};

DrDoc.SearchPresetForm = function (sourceElement, archiveName) {
    if (DrDocWeb.IsNullOrEmpty(archiveName)) {
        return DrDoc.GetSelectedArchive(function (archive) { return DrDoc.SearchPresetForm(sourceElement, archive); });
    }
    archiveName = DrDoc.GetSimpleArchiveName(archiveName);

    //console.log('DrDoc.SearchTemplateForm: ', sourceElement);
    return window.Node.LoadComponent({
        title: 'Datensatz erstellen mit Feldvorbelegung',
        sourceElement: sourceElement,
        targetElement: 'system/preset|content',
        getData: {
            archive: archiveName,
        }
    });
};
DrDoc.SearchTemplateForm = function (sourceElement, archiveName) {
    if (DrDocWeb.IsNullOrEmpty(archiveName)) {
        return DrDoc.GetSelectedArchive(function (archive) { return DrDoc.SearchTemplateForm(sourceElement, archive); });
    }
    archiveName = DrDoc.GetSimpleArchiveName(archiveName);

    //console.log('DrDoc.SearchTemplateForm: ', sourceElement);
    return window.Node.LoadComponent({
        title: 'Vorlagensuche',
        sourceElement: sourceElement,
        targetElement: 'system/search-template|content',
        getData: {
            archive: archiveName,
        }
    });
    /*
        return;
        
        // --
    
        console.log('data', DrDoc.GetUserData().Result);
        let modalSrc = '<div class="list-group">';
        let archiveSession = DrDoc.GetArchiveSession(archiveName);
        console.log('archiveSession', archiveSession);
        //for (let i in archiveSession.FieldSelectionNames_SearchTemplates)
        //{
        //    modalSrc += `<button class="list-group-item list-group-item-action" onclick="DrDocWeb.ModalGet(this).callback('${archiveSession.FieldSelectionNames_SearchTemplates[i]}'); ">${archiveSession.FieldSelectionNames_SearchTemplates[i]}</button>`;
        //}
        //for (let i in archiveSession.FieldSelections.VORLAGENSUCHE) {
        if (archiveSession.FieldSelections) {
            DrDocWeb.ObjectForEachSorted(archiveSession.FieldSelections.VORLAGENSUCHE, function (key, val) {
                modalSrc += `<button class="list-group-item list-group-item-action" onclick="DrDocWeb.ModalGet(this).callback('${key}'); ">${key}</button>`;
            });
    
            // DrDocWeb.ModalClose(this); 
    
            DrDocWeb.ObjectForEachSorted(archiveSession.FieldSelections.SEARCHTEMPLATE, function (key, val) {
                if (archiveSession.FieldSelections.VORLAGENSUCHE[key] === undefined) {
                    modalSrc += `<button class="list-group-item list-group-item-action text-secondary" onclick="DrDocWeb.ModalGet(this).callback('${key}'); ">${key}</button>`;
                }
            });
        }
        else {
            modalSrc += 'No Field Selection (Vorlagensuche / Suchvorlage) found!';
        }
    
        modalSrc += '</div>';
    
        let modal = DrDocWeb.Modal('Vorlagensuche', modalSrc, { fullScreen: false });
    
        modal.callback = (templateName) => {
            modal.hide();
            DrDoc.SearchTemplate(sourceElement, archiveName, templateName);
        };
        */
};
DrDoc.SearchTemplate = function (sourceElement, archiveName, templateName) {
    //if (archiveName === undefined || archiveName === null)
    //    archiveName = DrDoc.configDevice.get('view/selected-archive');
    if (DrDocWeb.IsNullOrEmpty(archiveName)) {
        return DrDoc.GetSelectedArchive(function (archive) { return DrDoc.SearchTemplate(sourceElement, archive, templateName); });
    }
    archiveName = DrDoc.GetSimpleArchiveName(archiveName);
    //let nodeId = 'system/list|content';
    DrDoc.SetViewList();
    return window.Node.LoadComponent({
        title: 'Vorlagensuche',
        sourceElement: sourceElement, //DrDoc.GetListNodeId(sourceElement, archiveName), //sourceElement,
        targetElement: DrDoc.GetListNodeId(sourceElement, archiveName),
        getData: {
            archive: archiveName,
            mode: 'template',
            value: templateName,
            //searchTemplateName: templateName,
            search: '', substring: false
        },
        postData: {},
        nav: 'push',
    }).then(DrDoc.SetViewInit);
};
DrDoc.SearchToDo = function (sourceElement, archiveName) {
    return DrDoc.SearchHyper(sourceElement, archiveName, 'TODOLISTE', '', 'Hypersuche To Do');
};
DrDoc.SearchInbox = function (sourceElement, archiveName) {
    return DrDoc.SearchHyper(sourceElement, archiveName, 'INBOX', '', 'Hypersuche Posteingang');
};
DrDoc.SearchHyper = function (sourceElement, archiveName, hyperName, hyperSearchText, title) {
    if (DrDocWeb.IsNullOrEmpty(archiveName)) {
        return DrDoc.GetSelectedArchive(function (archive) { return DrDoc.SearchHyper(sourceElement, archive, hyperName, hyperSearchText, title); });
    }
    archiveName = DrDoc.GetSimpleArchiveName(archiveName);
    let progressBarModal = DrDocWeb.ModalProgress(`Starte Hypersuche ${hyperName}..`);
    DrDoc.SetViewList();
    return window.Node.LoadComponent({
        title: title,
        //sourceElement: sourceElement,
        sourceElement: 'system/list', //DrDoc.GetListNodeId(sourceElement, archiveName),
        targetElement: 'system/list', //DrDoc.GetListNodeId(sourceElement, archiveName),
        getData: { archive: archiveName, mode: 'hyper', value: hyperName, search: hyperSearchText },
        nav: 'push',
    }).then(function () {
        DrDoc.SetViewInit();
        DrDoc.updateMainMenuExpansion();
        DrDoc.SearchCountElement();
        progressBarModal.close();
    });
};
DrDoc.SearchText = function (sourceElement, archiveName, searchText) {
    //if (archiveName === undefined || archiveName === null)
    //    archiveName = DrDoc.configDevice.get('view/selected-archive');
    if (DrDocWeb.IsNullOrEmpty(archiveName)) {
        return DrDoc.GetSelectedArchive(function (archive) { return DrDoc.SearchText(sourceElement, archive, searchText); });
    }
    archiveName = DrDoc.GetSimpleArchiveName(archiveName);
    DrDoc.SetViewList();
    return window.Node.LoadComponent({
        title: 'Datensatz-Liste',
        sourceElement: sourceElement,
        targetElement: DrDoc.GetListNodeId(sourceElement, archiveName),
        getData: { archive: archiveName, mode: 'textretrieval', value: searchText },
        nav: 'push',
    }).then(DrDoc.SetViewInit);
};

DrDoc.TreeSearchRecursive = function (sourceElement, archiveName, targetNodeID) {
    return DrDoc.ActionRecursive(sourceElement, archiveName, targetNodeID, 'searchfields');
};

DrDoc.ActionRecursive = function (sourceElement, archiveName, targetNodeID, mode, getDataEx) {
    let searchData = {
        archive: archiveName,
        recursive: false,
        mode: mode,
        page: 0,
        tree: false,
        'tree-sub': true,
        //'recursive-query': ''
    };
    DrDocWeb.kvp_get(sourceElement, targetNodeID, 'search', 'field_', searchData, true);
    DrDocWeb.kvp_get(sourceElement, targetNodeID, 'recursive', '', searchData, false);

    /*if (DrDocWeb.IsNullOrEmpty(mode) && !DrDocWeb.IsNullOrEmpty(searchData['recursive-query'])) {
        searchData = searchData['recursive-query'];
        if (typeof searchData === 'string')
            searchData = DrDocWeb.QueryStrToObject(searchData);
    }*/
    if (DrDocWeb.IsNullOrEmpty(mode) && DrDocWeb.IsNullOrEmpty(searchData['field_' + DrDoc.ID_FIELD])) {
        searchData['mode'] = 'searchfields';
        searchData['field_' + DrDoc.ID_FIELD] = '*';
    }

    if (getDataEx !== undefined && getDataEx !== null) {
        Object.assign(searchData, getDataEx);
    }

    console.log('DrDoc.TreeSearchRecursive: ', searchData);

    //Object.assign(searchData, );

    return window.Node.LoadComponent({
        nav: false,
        sourceElement: sourceElement,
        targetElement: targetNodeID,
        getData: searchData,
        postData: {}
    });
};

// Datensatz-Zeile aktualisieren
DrDoc.UpdateDatasetRow = function (sourceElement, archiveName, documentId) {
    var rowElem = DrDoc.GetTableRowElementByID(sourceElement, archiveName, documentId);
    if (rowElem === undefined || rowElem === null || rowElem === false) {
        console.warn('DrDoc.UpdateDatasetRow: rowElem not found: ', sourceElement, archiveName, documentId);
        return undefined;
    }


    //setTimeout(function(){
    // system/list | content | wfmain | TODOLISTE | 19735
    //let searchTemplateName2 = DrDoc.GetListTemplateName(rowElem);
    //let searchTemplateName = f(rowElem, archiveName);
    //console.log('DrDoc.UpdateDatasetRow', rowElem, sourceElement, archiveName, documentId, searchTemplateName); //, ' / ', searchTemplateName2);

    let getData = {
        archive: archiveName,
        searchTemplateName: DrDoc.GetSearchTemplate(rowElem, archiveName),
        //id: (documentId === undefined || documentId === null ? '' : documentId),
        //mode: 'get'
        mode: 'searchfields',
        selection: DrDoc.GetSearchFieldSelection(rowElem, archiveName),
        recursive: 'new',
        tree: false,
        'tree-sub': false,
    };
    getData['field_' + DrDoc.ID_FIELD] = documentId;

    return window.Node.LoadComponent({
        exact: true,
        title: 'Datensatz Zeile im Archiv ' + DrDoc.GetArchiveLabel(archiveName),
        sourceElement: rowElem,
        targetElement: rowElem,
        getData: getData,
        postData: {}
    });
    //}, 5000);
};

DrDoc.AiDataset = function (sourceElement, archiveName, documentIdField, documentId, aiMode, aiValue) {
    //let nodeId = DrDoc.GetMaskNodeId(sourceElement, archiveName);
    let nodeId = Node.GetNodeId(DrDoc.GetMaskNodeId(sourceElement, archiveName)) + '|ai';
    console.log('DrDoc.AiDataset: ', 'node-id:', nodeId, DrDoc.GetMaskNodeId(sourceElement, archiveName));

    return window.Node.LoadComponent({
        ignoreUnloadEvent: true,
        title: 'Datensatz KI Q&A im Archiv ' + DrDoc.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            mode: 'get',
            autolock: false,
            id_field: documentIdField,
            id: (DrDocWeb.IsNullOrEmpty(documentId) ? '' : documentId),
            ai: aiMode,
            value: (DrDocWeb.IsNullOrEmpty(aiValue) ? '' : aiValue),
        }
    })
        .then(function () {
            setTimeout(function () {
                /*//let valueElem = document.getElementsByName('value');
                let valueElem = DrDocWeb.GetElement(sourceElement, 
                console.log('DrDoc.AiDataset: ', valueElem);
                if (valueElem && valueElem.length > 0)
                {
                    valueElem[0].scrollIntoView();
                }*/

                //let objectSelector = DrDocWeb.GetElement(document, '.modal-body:has(#ai-chat-container)');
                let objectSelector = document.querySelector('.modal-body:has(#ai-chat-container)');
                if (objectSelector) {
                    //console.log('DrDoc.AiDataset: ', objectSelector, objectSelector2, document.querySelector('#ai-chat-container'));
                    objectSelector.scrollTo({ top: objectSelector.scrollHeight });
                }

                // ai-chat-input
                let input = document.querySelector('#ai-chat-input');
                if (input) {
                    input.scrollIntoView();
                    input.focus();
                }
            }, 100);
        });
};

/*DrDoc.AiDatasetChatRequest = function (sourceElement, archiveName, documentId, chatReqText) {
    let nodeId = DrDoc.GetMaskNodeId(sourceElement, archiveName) + '|ai';

    return window.Node.LoadComponent({
        ignoreUnloadEvent: true,
        title: 'Datensatz KI Q&A im Archiv ' + DrDoc.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            id: (DrDocWeb.IsNullOrEmpty(documentId) ? '' : documentId),
            mode: 'set',
            ai: 'init-chat-doc',
        }
    });
};*/

// Datensatz
DrDoc.SaveDataset = function (sourceElement, archiveName, documentId) {
    let nodeId = DrDoc.GetMaskNodeId(sourceElement, archiveName);

    //let elem = Node.GetElement(nodeId);
    //elem.beforeunload = undefined;

    return window.Node.LoadComponent({
        ignoreUnloadEvent: true,
        title: 'Datensatz speichern im Archiv ' + DrDoc.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            id: (DrDocWeb.IsNullOrEmpty(documentId) ? '' : documentId),
            mode: 'set'
        }
    }).then(data => {
        //console.log('SaveDataset (=> geladen): ', archiveName, 'set', sourceElement);
        // Wenn der Datensatz geladen wurde, Modal wieder schließen.
        let res = DrDocWeb.ModalClose(sourceElement);
        DrDoc.UpdateDatasetRow(sourceElement, archiveName, documentId);
    });
};
DrDoc._fn_Dataset = function (sourceElement, archiveName, documentId, action, text, getData) {
    let nodeId = DrDoc.GetMaskNodeId(sourceElement, archiveName);

    if (getData === undefined || getData === null)
        getData = {};

    getData.archive = archiveName;
    getData.id = (DrDocWeb.IsNullOrEmpty(documentId) ? '' : documentId);
    getData.mode = action;

    return window.Node.LoadComponent({
        title: text + ' im Archiv ' + DrDoc.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: getData
    }).then(data => {
        //console.log('LockDataset (=> geladen): ', archiveName, 'lock', sourceElement);
        // Wenn der Datensatz geladen wurde, Modal wieder schließen.
        let res = DrDocWeb.ModalClose(sourceElement);
    });
};
DrDoc.DeleteDataset = function (sourceElement, archiveName, documentId) {
    if (window.confirm('Soll der Datensatz gelöscht werden?'))
        return DrDoc._fn_Dataset(sourceElement, archiveName, documentId, 'delete', 'Datensatz löschen').then(data => {
            //DrDoc.UpdateDatasetRow(sourceElement, archiveName, documentId);
            var rowElem = DrDoc.GetTableRowElementByID(sourceElement, archiveName, documentId);
            if (rowElem === undefined || rowElem === null || rowElem === false) {
                console.warn('DrDoc.DeleteDataset: rowElem not found: ', sourceElement, archiveName, documentId);
                return undefined;
            }
            rowElem.classList.add('text-decoration-line-through'); // x-d-none');
        });
    else
        return null;
};
DrDoc.PresetDataset = function (sourceElement, archiveName, documentId, presetName) {
    return DrDoc._fn_Dataset(sourceElement, archiveName, documentId, 'preset', 'Datensatz (vor)belegen', { preset: presetName });
};
DrDoc.LockDataset = function (sourceElement, archiveName, documentId) {
    return DrDoc._fn_Dataset(sourceElement, archiveName, documentId, 'lock', 'Datensatz sperren');
};
DrDoc.UnlockDataset = function (sourceElement, archiveName, documentId) {
    return DrDoc._fn_Dataset(sourceElement, archiveName, documentId, 'unlock', 'Datensatz entsperren');
};
DrDoc.UnlockOnlyDataset = function (sourceElement, archiveName, documentId) {
    let nodeId = DrDoc.GetMaskNodeId(sourceElement, archiveName);
    return DrDocWeb.SendGet('model/crud', { archive: archiveName, action: 'unlock', id: documentId });
};
DrDoc.WfCompleteDataset = function (sourceElement, archiveName, documentId) {
    let nodeId = DrDoc.GetMaskNodeId(sourceElement, archiveName);

    //let elem = Node.GetElement(nodeId);
    //elem.beforeunload = undefined;

    return window.Node.LoadComponent({
        ignoreUnloadEvent: true,
        title: 'Workflow erledigen im Archiv ' + DrDoc.GetArchiveLabel(archiveName),
        sourceElement: sourceElement,
        targetElement: nodeId,
        getData: {
            archive: archiveName,
            id: (DrDocWeb.IsNullOrEmpty(documentId) ? '' : documentId),
            mode: 'wf'
        }
    }).then(data => {
        //console.log('WfCompleteDataset (=> geladen): ', archiveName, 'wf', sourceElement);
        // Wenn der Datensatz geladen wurde, Modal wieder schließen.
        let res = DrDocWeb.ModalClose(sourceElement);
        var prem1 = DrDoc.OnSelectNextDataset(sourceElement, archiveName, documentId);
        if (prem1 != undefined && prem1 != null) {
            prem1.then(function (d) {
                DrDoc.UpdateDatasetRow(sourceElement, archiveName, documentId);
            });
        }
        else {
            console.log('DrDoc.WfCompleteDataset: OnSelectNextDataset ERROR');
            DrDoc.UpdateDatasetRow(sourceElement, archiveName, documentId);
        }
    });
};
DrDoc.WfGetDataset = function (sourceElement, getDS, getDoc) //, linkArchiv, linkGuid)
{
    let formData = DrDocWeb.ClosestFormToObject(sourceElement, 1);

    let linkArchiv = formData['WF_LinkArchiv'];
    let linkGuid = formData['WF_LinkGUID'];

    if (DrDocWeb.IsNullOrEmpty(linkArchiv))
        return false;
    if (DrDocWeb.IsNullOrEmpty(linkGuid))
        return false;

    console.log('DrDoc.WfGetDataset: Form:  ', formData);

    let archive_arr = Dataset.GetTableRows(linkArchiv);
    let guid_arr = Dataset.GetTableRows(linkGuid);

    // Nach Archiv gruppieren
    let searchObj = {};
    for (let i in archive_arr) {
        let archiveName = archive_arr[i];
        let guid = guid_arr[i];
        if (DrDocWeb.IsNullOrEmpty(archiveName))
            continue;
        if (DrDocWeb.IsNullOrEmpty(guid))
            continue;

        archiveName = archiveName.toLowerCase();
        if (searchObj[archiveName] === undefined) {
            searchObj[archiveName] = [guid];
        }
        else {
            searchObj[archiveName].push(guid);
        }
    }

    console.log('DrDoc.WfGetDataset: WF Doks. 3: ', searchObj);

    for (let archiveName in searchObj) {
        if (searchObj[archiveName].length > 0 && getDoc) {
            // Dokument laden, wenn nur 1 Dokument
            console.log('DrDoc.MaskShowDocumentByField: ', archiveName, 'DrDocGUID', searchObj[archiveName]);
            DrDoc.MaskShowDocumentByField(null, archiveName, 'DrDocGUID', searchObj[archiveName].join('|'));
        }
        //else
        //{
        if (getDS) {
            // Feldsuche in neuem Fenster
            DrDoc.SearchFieldsInfo(null, archiveName, {
                DrDocGUID: searchObj[archiveName].join('|'),
            }, true);
        }
        //}
    }
    return true;
};


DrDoc.ID_FIELD = 'Dokument-Nr.';
DrDoc.MaskShowDocument = function (sourceElement, archiveName, documentId) {
    DrDoc.MaskShowDocumentByField(sourceElement, archiveName, DrDoc.ID_FIELD, documentId);
};
DrDoc.MaskGetDocumentUrlByField = function (archiveName, fieldName, fieldValue, page, sign, sign_create, sign_create_preset, sign_pos, sign_text_rel, sign_align) {
    //let url = `/model/document?archive=${archiveName}&action=get&original=false&id_field=${fieldName}&id=${fieldValue}`;

    /*let url = '/model/document?' + DrDocWeb.ObjectToQueryStr({
        archive: archiveName,
        action: 'get',
        original: false,
        id_field: fieldName,
        id: fieldValue
    });*/

    //let url = `/node/system/mask|content|${archiveName}|dataset|Bild?mode=get&archive=${archiveName}&id_field=${fieldName}&id=${fieldValue}`;
    //let url = `/node/system/mask|content|Bild?mode=get&archive=${archiveName}&id_field=${fieldName}&id=${fieldValue}&extern=true`;
    let url = '/node/system/mask|content|Bild?' + DrDocWeb.ObjectToQueryStr({
        mode: 'get',
        archive: archiveName,
        id_field: fieldName,
        id: fieldValue,
        extern: 'true',
        autolock: false,
        page: page,
        sign: sign,
        sign_create: sign_create,
        sign_create_preset: sign_create_preset,
        sign_pos: sign_pos,
        sign_text_rel: sign_text_rel,
        sign_align: sign_align,
    });

    return url;
};
DrDoc.MaskShowDocumentByField = function (sourceElement, archiveName, fieldName, fieldValue, page, sign, sign_create, sign_create_preset, sign_pos, sign_text_rel, sign_align) {
    let url = DrDoc.MaskGetDocumentUrlByField(archiveName, fieldName, fieldValue, page, sign, sign_create, sign_create_preset, sign_pos, sign_text_rel, sign_align);

    return DrDoc.MaskShowDocumentUrl(sourceElement, archiveName, url);
};
DrDoc.MaskShowDocumentUrl = function (sourceElement, archiveName, url) {
    // wenn es einWF Instanz ist, dann ausführen
    if (sourceElement !== undefined && sourceElement !== null) {
        let wfGetDs = DrDoc.WfGetDataset(sourceElement, false, true);
        if (wfGetDs === true) {
            return true;
        }
    }

    let wnd = DrDoc.GetDocumentWnd(archiveName, true, url);
    ///if (wnd.location == undefined || DrDocWeb.IsNullOrEmpty(wnd.location.href) || wnd.location.href == 'about:blank')
    //    wnd.location.href = url;
    //else
    //    wnd.location.replace(url);
};

DrDoc.CloseAllDocumentWnd = function () {
    console.log('DrDoc.CloseAllDocumentWnd ', window._docWindow);

    if (window._docWindow == null || window._docWindow == undefined)
        window._docWindow = {};

    for (var wndId in window._docWindow) {
        var wnd = window._docWindow[wndId];
        if (wnd != undefined && wnd != null)
            wnd.close();
        delete window._docWindow[wndId];
    }
};

DrDoc.GetDocumentWnd = function (archiveName, create, url) {

    if (DrDocWeb.IsNullOrEmpty(archiveName))
        archiveName = '_DEFAULT_';
    else
        archiveName = 'wnd-' + DrDocWeb.ChecksumCyrb53(archiveName).toString();

    if (DrDocWeb.IsNullOrEmpty(url)) {
        url = 'about:blank';
    }

    /*console.log('DrDoc.GetDocumentWnd: Open: ', url);
    if (url == 'about:blank')
    {
        return;
    }*/

    var setWndPos = function (wndObj) {
        //var left = DrDocWeb.FindLeftScreenBoundry(wndObj);
        //var top = DrDocWeb.FindTopScreenBoundry(wndObj);
        //console.log('setWndPos: / left: ', left, ' / top: ', top);
        //return;

        if (wndObj == undefined || wndObj == null)
            return false;

        //DrDoc.configDevice.set(`window/${archiveName}/ext`, 2);
        //console.log('DrDoc.GetDocumentWnd: RESIZE', archiveName, `window/${archiveName}/ext`, DrDoc.configDevice.get(`window/${archiveName}/ext`));

        try {
            /*if (wndObj.outerWidth !== undefined)
                console.log('DrDoc.GetDocumentWnd: RESIZE: WxH: ', wndObj, +wndObj.outerWidth, wndObj.outerHeight);

            if (wndObj.screenX !== undefined)
                console.log('DrDoc.GetDocumentWnd: RESIZE: XxY: ', wndObj, wndObj.screenX, wndObj.screenY, ' / ', wndObj.top, wndObj.left);
            */

            let w = 500;
            let h = w * 3.0 / 2.0;
            if (wndObj.width !== undefined) {
                w = wndObj.width;
                h = wndObj.height;
            }
            else if (wndObj.outerWidth !== undefined) {
                w = wndObj.outerWidth;
                h = wndObj.outerHeight;
            }
            DrDoc.configDevice.set(`window/${archiveName}/w`, w);
            DrDoc.configDevice.set(`window/${archiveName}/h`, h);

            /*if (wndObj.left !== undefined)
            {
                DrDoc.configDevice.set(`window/${archiveName}/x`, wndObj.left);
                DrDoc.configDevice.set(`window/${archiveName}/y`,wndObj.top);
            }
            else if (wndObj.screenLeft !== undefined)
            {
                DrDoc.configDevice.set(`window/${archiveName}/x`, wndObj.screenLeft);
                DrDoc.configDevice.set(`window/${archiveName}/y`,wndObj.screenTop);
            }*/
            //DrDoc.configDevice.set(`window/${archiveName}/x`, DrDocWeb.FindLeftScreenBoundry(wndObj));
            //DrDoc.configDevice.set(`window/${archiveName}/y`, DrDocWeb.FindTopScreenBoundry(wndObj));

            var left = DrDocWeb.FindLeftScreenBoundry(wndObj);
            var top = DrDocWeb.FindTopScreenBoundry(wndObj);
            //var left = wndObj.screenX + (wndObj.screen.width / 2) - (w / 2);
            //var top = (wndObj.screen.height / 2) - (h / 2);
            DrDoc.configDevice.set(`window/${archiveName}/x`, left);
            DrDoc.configDevice.set(`window/${archiveName}/y`, top);

            if (wndObj.screen !== undefined) {
                DrDoc.configDevice.set(`window/${archiveName}/ext`, wndObj.screen.isExtended);
                /*if (wndObj.screenX !== undefined)
                {
                    DrDoc.configDevice.set(`window/${archiveName}/x`, wndObj.screen.width - wndObj.screenX);
                    DrDoc.configDevice.set(`window/${archiveName}/y`, wndObj.screen.height - wndObj.screenY);
                }*/
            }
        }
        catch (ex) {
            //console.warn('setWndPos', ex, wnd);
        }
    };

    // window._docWindow[ARCHIVE]

    // Falls das Dokument-Fenster bereits geladen wurde, diese wiederverwenden, damit der Focus nicht verloren geht.
    if (window._docWindow == null || window._docWindow == undefined)
        window._docWindow = {};

    //console.log('DrDoc.GetDocumentWnd(1): ', window._docWindow, archiveName, create);

    let wnd = window._docWindow[archiveName];
    if (wnd !== undefined && wnd !== null) // && wnd.location !== undefined && wnd.location !== null)
    {


        //if (wnd.document.readyState !== 'complete')
        /*if (wnd.document !== undefined && wnd.document.readyState !== 'complete')
        {
            return DrDoc.GetDocumentWnd(archiveName, create, url);
        }*/

        //if (wnd.closed === false)
        //    console.log('DrDoc.GetDocumentWnd A: SHOW 1 exit/ret', archiveName, ' closed: ', wnd.closed, wnd);
        //else
        //    console.log('DrDoc.GetDocumentWnd A: SHOW 2 close/open', archiveName, ' closed: ', wnd.closed, wnd);

        /*if (wnd.closed === true)
        {
            console.log('DrDoc.GetDocumentWnd: Window Reactivate');
            wnd.open('about:blank');
        }*/
        //console.log('DrDoc.GetDocumentWnd: Window Reactivate 1 ', wnd, wnd.closed, wnd.width, 'x', wnd.height, ' / x', wnd.left, ', y', wnd.top);

        // A: Fenster immer schließen
        //wnd.close();

        // B: Fenster wiederverwenden, wenn es noch offen ist

        if (wnd.closed === undefined || wnd.closed === false) {
            setWndPos(wnd);

            //console.log('DrDoc.GetDocumentWnd A: Reuse ', archiveName, wnd, wnd.closed);

            if (!DrDocWeb.IsNullOrEmpty(url))
                wnd.location.replace(url);

            //wnd.focus();
            //wnd.blur();

            return wnd;
        }

        console.log('DrDoc.GetDocumentWnd A: Try Close ', archiveName, wnd, wnd.closed);
        try {
            wnd.close();
            //wnd.close('','_parent','');
        } catch (ex) { }
        delete window._docWindow[archiveName];
        //wnd = null;
    }

    if (create) {
        //if (wnd !== undefined && wnd !== null)
        //console.log('DrDoc.GetDocumentWnd: Window reactivate 2 ', wnd, wnd.closed, wnd.width, 'x', wnd.height, ' / x', wnd.left, ', y', wnd.top);
        //console.log('DrDoc.GetDocumentWnd: OPEN', archiveName);

        var newDocWindow = window.open(
            (DrDocWeb.IsNullOrEmpty(url) ? 'about:blank' : url),
            //'Dokument_' + archiveName,
            //'Dokument (' + archiveName + ')',
            //'_self',
            '_blank',
            'height=700,width=500,status=no,toolbar=no,location=no,menubar=no,scrollbars=yes,modal=yes'); //,alwaysRaised=yes,alwaysLowered=yes,dependent=yes');

        if (DrDoc.configDevice.has(`window/${archiveName}/w`)) {
            //console.log('DrDoc.GetDocumentWnd Reset: ', archiveName, DrDoc.configDevice.get(`window/${archiveName}/w`));

            if (newDocWindow.screen != undefined)
                newDocWindow.screen.isExtended = DrDoc.configDevice.get(`window/${archiveName}/ext`);

            //newDocWindow.left = +DrDoc.configDevice.get(`window/${archiveName}/x`);
            //newDocWindow.top = +DrDoc.configDevice.get(`window/${archiveName}/y`);
            //newDocWindow.leftScreenBoundry = +DrDoc.configDevice.get(`window/${archiveName}/x`);
            //newDocWindow.topScreenBoundry = +DrDoc.configDevice.get(`window/${archiveName}/y`);
            newDocWindow.moveTo(DrDoc.configDevice.get(`window/${archiveName}/x`), DrDoc.configDevice.get(`window/${archiveName}/y`));
            //newDocWindow.moveBy(DrDoc.configDevice.get(`window/${archiveName}/x`), DrDoc.configDevice.get(`window/${archiveName}/y`));

            //newDocWindow.width = +DrDoc.configDevice.get(`window/${archiveName}/w`);
            //newDocWindow.height = +DrDoc.configDevice.get(`window/${archiveName}/h`);
            newDocWindow.resizeTo(DrDoc.configDevice.get(`window/${archiveName}/w`), DrDoc.configDevice.get(`window/${archiveName}/h`));

            //if (newDocWindow.screen != undefined)
            //    newDocWindow.screen.isExtended = DrDoc.configDevice.get(`window/${archiveName}/ext`);
        }

        window._docWindow[archiveName] = newDocWindow;

        //newDocWindow.postMessage("hello there!", "http://example.com");

        var fnEvent = function (e) {
            //console.log('DrDoc.GetDocumentWnd(load): ', '1:', e, '2:', e.target, '3:', this);

            //setWndPos(e.target);
            //setWndPos(newDocWindow);
            setWndPos(window._docWindow[archiveName]);
            //setWndPos(this);
        };

        // Bei Änderung Fenster Pos. speichern
        newDocWindow.addEventListener('beforeunload', fnEvent, false);
        newDocWindow.addEventListener('load', fnEvent);
        newDocWindow.addEventListener('resize', fnEvent);
        newDocWindow.addEventListener('mouseout', fnEvent);
        newDocWindow.addEventListener('close', fnEvent);

        /*setTimeout(function (e) {
            setWndPos(e.target);
            //setWndPos(newDocWindow);
            //setWndPos(this);
        }, 1000);
        setTimeout(function (e) {
            setWndPos(e.target);
            setWndPos(newDocWindow);
            //setWndPos(this);
        }, 5000);*/

        /*var ro = new ResizeObserver(entries => {
            for (let entry of entries) {
              const cr = entry.contentRect;
              setWndPos(cr);
            }
        });
        ro.observe(newDocWindow.document);*/

        /*newDocWindow.addEventListener('load', function(e)
        {
            console.log('New Window has been loadad', e, e.target.documentElement);
        }, true);
        mainWindow.focus();
        newDocWindow.blur();*/
        //console.log('DrDoc.GetDocumentWnd(2): ', window._docWindow, archiveName, create);


        return newDocWindow;
    }
    else {
        //console.log('DrDoc.GetDocumentWnd: Window delete ', archiveName, wnd);
        //delete window._docWindow[archiveName];
        return undefined;
    }
};

// | ---        | ---      | --- |
// | Mode       | Readonly | OK |
// | ---        | ---      | --- |
// | Extern Wnd | true     | -   |
// | Modal      | true     | -   |
// | Control    | true     | -   |
// | Extern Wnd | false    | -   |
// | Modal      | false    | -   |
// | Control    | false    | -   | 
// | ---        | ---      | --- |
// DrDoc.CreateMarkdownElement('srcelemid', true, 'modal', null, true, false, `Name: (Name)`);
DrDoc.CreateMarkdownElement = function (sourceElement, isReadOnly, viewMode, mdMode, mdForceCreateWnd, mdAutosize, title) {
    if (DrDocWeb.IsNullOrEmpty(sourceElement)) {
        console.warn('DrDoc.CreateMarkdownElement: sourceElement == null: ', sourceElement);
        return null;
    }

    let targetElementId = '';
    if (typeof sourceElement === 'string') {
        targetElementId = sourceElement;
        sourceElement = document.getElementById(targetElementId);
    }
    else {
        targetElementId = sourceElement.getAttribute('id');
    }

    if (sourceElement == undefined || sourceElement == null) {
        console.warn('DrDoc.CreateMarkdownElement: targetElementId == null: ', targetElementId, sourceElement);
        return null;
        //return undefined;
    }

    // Wenn kein MD-Mode angegeben wurde, dann aus Settings übernehmen
    if (mdMode === undefined || mdMode === null) {
        var mdModeCtrl = DrDoc.configUser.get('view/markdown-ctrl', false);
        var mdModeModal = DrDoc.configUser.get('view/markdown-modal', true);

        //console.log('DrDoc.CreateMarkdownElement: MD-Modal: Mode: ', mdMode, mdModeModal, mdModeCtrl);
        mdMode = mdModeModal === true || mdModeCtrl === true;
        //console.log('DrDoc.CreateMarkdownElement: MD-Modal: Mode 2: ', mdMode);
    }

    var validateElemValue = function (retValue) {
        if (mdMode == true && !DrDocWeb.IsNullOrEmpty(retValue)) {
            // keine "<br>" direkt vor einem "<ul>" für Markdown-Text erlauben!
            // da Toast-UI sonst den Text leert
            const lineBreakReplacement = "<br>"; // funktioniert nicht
            //const lineBreakReplacement = "<br/>"; // funktioniert nicht
            //const lineBreakReplacement = "\\"; // funktioniert nicht
            //const lineBreakReplacement = "\\\r\n"; // funktioniert nicht
            //const lineBreakReplacement = "&#10;"; // funktioniert nur zur Anzeige, jedoch nicht wenn man zum Markdown Modus in den WYSIWYG Modus wechselt
            //const lineBreakReplacement = "&#10;\\"; // funktioniert nicht
            //const lineBreakReplacement = "  &#10;"; // <space><space>\n
            //const lineBreakReplacement = '\\\\\\n'; // "\\\n"
            //const lineBreakReplacement = "\\\\\n"; // "\\ \n"
            //const lineBreakReplacement = "<br/>";
            retValue = retValue.replaceAll('<br>', lineBreakReplacement).replaceAll('<br/>', lineBreakReplacement).replaceAll('<br />', lineBreakReplacement);
            retValue = retValue.replaceAll(lineBreakReplacement + '<ul>', '<ul>').replaceAll(lineBreakReplacement + '<ol>', '<ol>');
            retValue = retValue.replaceAll(lineBreakReplacement + '<ul>', '<ul>').replaceAll(lineBreakReplacement + '<ol>', '<ol>');

            // MD Inline Code in Auflistungen verbieten
            // <li>`Test`</li>
            //retValue = retValue.replace(/(?<=\<li.*\>.*)\`([^\`]+)\`(?=.*\<\/li\>)/gi, '$1');

            // Pipe Symbol "|" in Tabellen-Zellen escapen, auch wenn es innerhalb von Inline-Code (z.B. `Code1|Code2`) steht.
            // ab 17.12.2024 eingetragen
            //retValue = retValue.replace(/(?<=\n\|\x20[^\r\n]*\`[^\r\n]*)(?<!\\)(\|)(?=[^\r\n]*\`)/gi, '\\$1');
            //retValue = retValue.replace(/(?<=\n\|\x20.*\`.*)(?<!\\)(\|)(?=.*\`)/gi, '\\$1');
            // ab 06.02.2025
            // retValue = retValue.replace(/(?<=(\x20|\>)\`[^\r\n\`]*)(?<!\\)(\|)(?=[^\r\n\`]*\`(\x20|\<))/gi, '\\$1');
            // ab 20.02.2025
            retValue = retValue.replace(/(?<=\|[^\r\n\|\`\>]*(?:\x20|\>)\`[^\r\n\`]*)(?<!\\)(\|)(?=[^\r\n\`]*\`(\x20|\<))/gi, '\\$1');

            // Pipe Symbol "|" In <li> Auflistungen escapen
            //retValue = retValue.replace(/(?<=\<li[^\>]*\>[^\>\<]*)(?<!\\)(\|)(?=.*\<\/li\>)/gi, '\\$1');
            // Pipe Symbol "|" Innerhalb von HTML-Code escapen
            //retValue = retValue.replace(/(?<=\<[a-z]{1,2}[^\>]*\>[^\>\<]*)(?<!\\)(\|)(?=.*\<\/[a-z]{1,2}\>)/gi, '\\$1');
            // ab 17.12.2024 ausgetragen
            retValue = retValue.replace(/(?<=\<li[^\>]*\>[^\>\<]*)(?<!\\)(\|)(?=.*\<\/li\>)/gi, '\\$1');

            // innerhalb von ```text ...  ``` den Text "```" escapen
            retValue = retValue.replace(/(?<=\n\`\`\`[^\`]*)(?<!\\)(\`\`\`)(?=[^\`]*\`\`\`)/gi, '\`\`\`');
        }
        return retValue;
    };

    var getElemValue = function () {
        //console.log('DrDoc.CreateMarkdownElement: getElemValue: ', sourceElement.value, sourceElement.innerHTML);

        let retValue = '';
        if (!DrDocWeb.IsNullOrEmpty(sourceElement.value))
            retValue = sourceElement.value;
        else if (!DrDocWeb.IsNullOrEmpty(sourceElement.innerHTML))
            retValue = sourceElement.innerHTML;
        else if (!DrDocWeb.IsNullOrEmpty(sourceElement.innerText))
            retValue = sourceElement.innerText;

        return validateElemValue(retValue);
    };

    var contentElement = null;

    if (mdMode == true || viewMode == 'window' || viewMode == 'iframe') {
        // => Markdown Mode

        let url = '/node/system/md?id=' + targetElementId + '&readonly=' + (isReadOnly === true ? 'true' : 'false');
        var mdCom = new BroadcastChannel('md-' + targetElementId);
        //var initValue = sourceElement.value;

        var updateValue = function () {
            //console.log('MD: updateValue Wnd ', getElemValue(), '   //    ', sourceElement.value);
            mdCom.postMessage(getElemValue());
        };

        // rekursion vermeiden
        var evIsActive = true;

        // Textarea/sourceElement updaten, wenn Markdown geändert wird
        mdCom.onmessage = function (event) {
            //console.log('MD: Receive Value', event);
            // textarea updaten
            evIsActive = false;
            sourceElement.value = validateElemValue(event.data);
            evIsActive = true;
        };

        // Markdown updaten, wenn Textarea/sourceElement geändert wird
        sourceElement.addEventListener('change', function (e) {
            if (evIsActive)
                updateValue();
        });

        if (viewMode == 'window') {
            // Window
            let wnd = DrDoc.GetDocumentWnd('md-' + targetElementId, (mdForceCreateWnd === true), url); // + '#' + DrDocWeb.RandomChars(6));
            if (wnd == undefined || wnd == null) {
                console.log('MD Wnd: not found: ', targetElementId);
                // Window existiert nicht
                return null;
            }
            wnd.updateValue = updateValue;
            /*wnd.contentWindow.addEventListener('load', function(e) {
                wnd.updateValue();
            });*/
            //wnd.location.href = url + '#' + DrDocWeb.RandomChars(6);

            // Wenn das Fenster bereits geladen wurdem dann direkt Wert updaten, ansonsten im Load-Event laden
            if (wnd && wnd.contentWindow && wnd.contentWindow.document.readyState === 'complete') {
                updateValue();
            }
            else {
                wnd.addEventListener('load', function (e) {
                    updateValue();
                });
            }
            wnd.addEventListener('popstate', function (e) {
                console.log('MD Wnd: popstate');
                setTimeout(updateValue, 1000);
            });
            /*wnd.addEventListener('beforeunload', function(e) {
                console.log('MD Wnd: beforeunload');
                setTimeout(updateValue, 4000);
            });
            wnd.addEventListener('unload', function(e) {
                console.log('MD Wnd: unload');
                setTimeout(updateValue, 200);
            });
            updateValue();*/

            //setTimeout(updateValue, 100);
            //setTimeout(updateValue, 300);
            setTimeout(updateValue, 2000);

            return wnd;
        }
        else {
            // Iframe
            contentElement = document.createElement('iframe');
            contentElement.src = url;

            // Textarea verbergen
            //sourceElement.style.display = 'none';

            contentElement.updateValue = updateValue;
            //setTimeout(updateValue, 2600);

            // erst wenn das Element eingebunden wurde, und anschließend die Seite geladen wurde, "postMessage" mit Text übergeben.
            //contentElement.addEventListener('load', function(e0) {
            /*setTimeout(function() {
                updateValue();
                while (contentElement.contentWindow == undefined || contentElement.contentWindow == null)
                {
                    // wait..
                    ;;
                }
                contentElement.contentWindow.addEventListener('load', function(e) {
                    console.log('DrDoc.CreateMarkdownElement / contentElement.contentWindow.addEventListener(load)');
                    updateValue();
                });
                console.log('DrDoc.CreateMarkdownElement / setTimeout');
                updateValue();
            }, 100);*/
            contentElement.addEventListener('load', function (e) {
                console.log('DrDoc.CreateMarkdownElement: iframe.addEventListener(load)');
                updateValue();
            });
            //});
            contentElement.id = 'md-iframe-' + targetElementId;
            contentElement.style.outline = 'none';
            contentElement.style.border = 'none';
            contentElement.style.borderStyle = 'none';
            contentElement.style.borderWidth = '0';
            contentElement.frameborder = '0';

            updateValue();

            if (viewMode != 'window' && viewMode != 'modal') {
                if (mdAutosize === true) {
                    //DrDocWeb.IframeAutosize(contentElement, '.toastui-editor-main-container');
                    //DrDocWeb.IframeAutosize(contentElement, '.toastui-editor-contents');
                    // Readonly in voller Höhe anzeigen
                    if (isReadOnly === true)
                        DrDocWeb.IframeAutosize(contentElement, '.ProseMirror');
                    else
                        DrDocWeb.IframeAutosize(contentElement, '.ProseMirror', undefined, undefined, '100vw', '90vh');
                    //DrDocWeb.IframeAutosize(contentElement, '.ProseMirror.toastui-editor-contents');
                    //DrDocWeb.IframeAutosize(contentElement, '');

                    /*setTimeout(function(){
                        //DrDocWeb.IframeAutosize(contentElement, '.ProseMirror.toastui-editor-contents');
                        //DrDocWeb.IframeAutosize(contentElement, '.toastui-editor.ww-mode');
                        DrDocWeb.IframeAutosize(contentElement, '.toastui-editor-contents');
                    }, 1000);*/
                }
            }
        }
    }
    else {
        // Text Mode / kein Markdown Mode

        //console.log('DrDoc.CreateMarkdownElement: Element: ', sourceElement);
        var elemValue = getElemValue();
        //console.log('DrDoc.CreateMarkdownElement: Text (no MD): ', elemValue);
        if (DrDocWeb.IsNullOrEmpty(elemValue))
            elemValue = '';
        else
            elemValue = elemValue.replaceAll('<', '&lt;').replaceAll('>', '&gt;');

        contentElement = document.createElement('div');
        if (isReadOnly) {
            contentElement.innerHTML = `<pre>${elemValue}</pre>`;
        }
        else {
            contentElement.innerHTML = `<textarea class="form-control" style="width: 100%; height: 100%;" rows="12" id="${targetElementId}--textarea" onchange="document.getElementById('${targetElementId}').value = this.value;">${elemValue}</textarea>`;
        }
    }

    if (viewMode != 'window' && viewMode != 'modal') {
        // sourceElement ausblenden
        sourceElement.style.display = 'none';
        // iframe anhängen
        if (sourceElement.parentNode) {
            if (!DrDocWeb.IsNullOrEmpty(contentElement.id)) {
                let contentElementOld = sourceElement.parentNode.querySelector('#' + contentElement.id);
                if (contentElementOld)
                    sourceElement.parentNode.removeChild(contentElementOld)
            }
            sourceElement.parentNode.appendChild(contentElement);
            DrDocWeb.IframeAutosize(contentElement, '.ProseMirror', undefined, undefined, '100vw', '100vh');
        }
    }

    if (viewMode == 'modal') {

        if (contentElement.style !== undefined) {
            contentElement.style.width = 'calc(100% + 2rem)';
            contentElement.style.height = 'calc(100% + 1.75rem)';
            contentElement.style.margin = '-1rem -1rem -1rem -1rem';
        }

        DrDocWeb.Modal(title, contentElement, {
            //fullScreen: (md === true ? true : false)
            fullScreen: true
        }).show();
    }

    return contentElement;
};

DrDoc.SignIn = function () {
    return window.Node.LoadComponent({
        title: 'Benutzer anmelden',
        sourceElement: null,
        targetElement: 'system/auth|content',
        getData: { mode: 'signin', ret: window.location.href }
    });
};
DrDoc.SignInAction = function (elem) {
    return window.Node.LoadComponent({
        title: 'Benutzer Anmeldung',
        sourceElement: elem,
        targetElement: 'system/auth|content',
        getData: { mode: 'signin', ret: window.location.href },
        postData: {
            username: elem['username'].value,
            password: elem['password'].value,
            totp: elem['totp'] != null ? elem['totp'].value : ''
        },
        requestMethod: 'POST'
    });
};
DrDoc.SignOut = function (allSessions) {
    return window.Node.LoadComponent({
        title: 'Benutzer abmelden',
        sourceElement: null,
        targetElement: 'system/auth|content',
        getData: { mode: (allSessions === true ? 'signout-all' : 'signout'), ret: window.location.href }
    });
};
DrDoc.TotpEnroll = function () {
    return window.Node.LoadComponent({
        title: 'TOTP Enroll',
        sourceElement: null,
        targetElement: 'system/auth|content',
        getData: { mode: 'totp-enroll', ret: window.location.href }
    });
};
DrDoc.TotpReset = function () {
    return window.Node.LoadComponent({
        title: 'TOTP Reset',
        sourceElement: null,
        targetElement: 'system/auth|content',
        getData: { mode: 'totp-reset', ret: window.location.href }
    });
};
DrDoc.DevTrust = function (devid) {
    DrDocWeb.SetCookie('devsid', devid, 365);
    return window.Node.LoadComponent({
        title: 'Device Trust',
        sourceElement: null,
        targetElement: 'system/auth|content',
        getData: { mode: 'dev-trust', ret: window.location.href }
    });
    /*{
        username: elem['username'].value,
        password: elem['password'].value,
        totp: elem['totp'] != null ? elem['totp'].value : '',
        'dev-trust': elem['dev-trust'] != null ? elem['dev-trust'].value : ''
    }*/
};

// --

// Drag n Drop Files / Upload

DrDoc._Document_GetFormDataOnDropInternal = function (ev) {
    DrDoc._Document_OnDragLeaveInternal(ev);

    console.log('DrDoc._Document_GetFormDataOnDropInternal: ', ev);

    return DrDocWeb.GetFormDataFromEvent(ev);
};
DrDoc._Document_OnDragOverInternal = function (elem, ev) {
    console.log('DrDoc._Document_OnDragOverInternal');

    //console.log('DragOverHandler: File(s) in drop zone', ev, elem);
    /*if (elem.getAttribute('data-can-drop') != 'true')
    {
        return;
    }*/

    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();

    //ev.target.classList.add('drop-hover');
    elem.classList.add('drop-hover');
};
DrDoc._Document_OnDragLeaveInternal = function (ev) {
    if (ev !== undefined) {

        console.log('DrDoc._Document_OnDragLeaveInternal: ', ev.target);

        /*if (ev.target != undefined && ev.target != null && ev.target.getAttribute('data-can-drop') != 'true') {
            return;
        }*/

        console.log('DrDoc._Document_OnDragLeaveInternal: ', ev.target.getAttribute('data-can-drop') != 'true', ev.target == this);

        document.querySelectorAll('.drop-hover').forEach(function (elem) {
            elem.classList.remove('drop-hover');
        });

        ev.preventDefault();

        /*if (ev.target)
            ev.target.classList.remove('drop-hover');
        }
        document.querySelectorAll('[ondragover]').forEach(function (elem) {
            elem.classList.remove('drop-hover');
        });*/
    }
};
DrDoc.Document_OnDragOver = function (elem, _ev, archiveName, presetName, idFieldName, documentId, aiCreateMode) {
    archiveName = DrDoc.GetSimpleArchiveName(archiveName);

    if (elem != undefined && elem.getAttribute('data-can-drop') != 'true') {
        console.log('DrDoc.Document_OnDragOver: elem data-can-drop != true: ', elem);
        return;
    }
    if (_ev != undefined && _ev.target.getAttribute('data-can-drop') != 'true') {
        if (_ev != undefined && _ev.target.parentNode.getAttribute('data-can-drop') != 'true') {
            console.log('DrDoc.Document_OnDragOver: _ev.target data-can-drop != true: ', elem);
            return;
        }
    }
    console.log('DrDoc.Document_OnDragOver', elem);

    // dragover, dragleave, drop
    DrDoc._Document_OnDragOverInternal(elem, _ev);
    //console.log('DrDoc.Document_OnDragOver: on Drag ');

    // a dragged item leaves a valid drop target.
    elem.ondragleave = DrDoc._Document_OnDragLeaveInternal;

    // an item is dropped on a valid drop target.
    elem.ondrop = function (ev) {
        /*if (ev.target.getAttribute('data-can-drop') != 'true')
        {
            return;
        }*/

        document.querySelectorAll('.drop-hover').forEach(function (elem) {
            elem.classList.remove('drop-hover');
        });

        //console.log('DrDoc.Document_OnDragOver: File(s) dropped in zone', ev, this, elem);
        var formData = DrDoc._Document_GetFormDataOnDropInternal(ev);
        DrDoc.UploadDocument(ev.target, archiveName, presetName, idFieldName, documentId, aiCreateMode, formData);
    };
    /*if (elem.childNodes != null)
    {
        elem.childNodes.forEach(function(childElem)
        {
            //childElem.ondrop = function(_ev2) { return elem.ondrop();
            childElem.ondrop = elem.ondrop;
            childElem.ondragleave = elem.ondragleave;
            childElem.ondragover = function(_ev2) {
                return DrDoc.Document_OnDragOver(elem, _ev2, archiveName, presetName, idFieldName, documentId, aiCreateMode);
            };
        });
    }*/
};

DrDoc.UploadDocumentFile = function (sourceElement, archiveName, presetName, idFieldName, documentId, aiCreateMode, multiple, mimeType, getDocument) {
    // <input type="file" id="fileElem" multiple accept="image/*" style="display:none" />
    var fileElem = document.createElement('input');
    fileElem.style.display = 'none';
    fileElem.setAttribute('type', 'file');
    if (!DrDocWeb.IsNullOrEmpty(mimeType))
        fileElem.setAttribute('accept', mimeType); //'image/*');
    if (multiple)
        fileElem.setAttribute('multiple', 'true');
    fileElem.addEventListener("change", function (e) {
        DrDoc.UploadDocument(sourceElement, archiveName, presetName, idFieldName, documentId, aiCreateMode, fileElem, getDocument);
        fileElem.remove();
    }, false);
    fileElem.click();
};

DrDoc.UploadDocument = function (sourceElement, archiveName, presetName, idFieldName, documentId, aiCreateMode, formData, getDocument) {
    console.log(`DrDoc.UploadDocument(sourceElement: ${sourceElement}, archiveName: ${archiveName}, presetName: ${presetName}, idFieldName: ${idFieldName}, documentId: ${documentId}, aiCreateMode: ${aiCreateMode}, formData: ${formData}, getDocument: ${getDocument})`);
    if (formData == undefined || formData == null || formData === false) {
        // kein Dokument vorhanden
        console.log('DrDoc.Document_OnDragOver: elem.ondrop: kein Dokument beim Drop vorhanden');
        return;
    }

    //_ev.preventDefault();
    if (DrDocWeb.IsNullOrEmpty(archiveName)) {
        console.log('DrDoc.UploadDocument: 2nd order / sel archive / archiveName is empty');
        return DrDoc.GetSelectedArchive(function (archive) { return DrDoc.UploadDocument(sourceElement, archive, presetName, idFieldName, documentId, aiCreateMode, formData, getDocument); });
    }

    let stateModal = DrDocWeb.ModalInfo('', 'Uploading Document...');
    formData = DrDocWeb.GetFormDataFromEvent(formData);

    var formGetData = {};
    var formPostData = {};
    Node.ParseFormData(sourceElement, formGetData, formPostData, false);

    //let dsExists = searchNewVersionObj[idFieldName] != undefined && searchNewVersionObj[idFieldName].length > 0 && !DrDocWeb.IsNullOrEmpty(searchNewVersionObj[idFieldName]); // && !DrDocWeb.IsNullOrEmpty(documentId) && documentId != '0';
    let dsExists = !DrDocWeb.IsNullOrEmpty(idFieldName) && !DrDocWeb.IsNullOrEmpty(documentId) && documentId != '0';
    //let modeCreate = searchNewVersionObj[DrDoc.ID_FIELD].length > 0 && !DrDocWeb.IsNullOrEmpty(documentId) && documentId != '0';
    console.log('DrDoc.UploadDocument: dsExists: ', dsExists);

    let sendCallback = null;
    if (aiCreateMode === true) {
        console.log('DrDoc.UploadDocument: elem.ondrop: formPostData, formData - AI-CREATE: ', formPostData, formData);
        sendCallback = DrDocWeb.Send('POST', 'model/document', { archive: archiveName, action: 'ai-create', preset: presetName, value: formPostData }, formData);
    }
    else if (dsExists) {
        console.log('DrDoc.UploadDocument: elem.ondrop: formPostData, formData - SET: ', formPostData, formData);
        sendCallback = DrDocWeb.Send('POST', 'model/document', { archive: archiveName, action: 'set', id_field: idFieldName, id: documentId, value: formPostData }, formData);
    }
    else {
        console.log('DrDoc.UploadDocument: elem.ondrop: formPostData, formData - CREATE: ', formPostData, formData);
        //sendCallback = DrDocWeb.Send('POST', 'model/document', { archive: archiveName, action: 'create', preset: presetName, value: formPostData }, formData, 'form');
        sendCallback = DrDocWeb.Send('POST', 'model/document', { archive: archiveName, action: 'create', preset: presetName, value: formPostData }, formData);
    }

    return sendCallback.then(function (reponse_Str) {
        let reponse = DrDocWeb.JsonToObject(reponse_Str);
        console.log('DrDoc.UploadDocument: response', reponse);

        if (stateModal)
            stateModal.close();

        if (reponse.HasError) {
            DrDocWeb.ModalError('Upload Fehler', ('Datei konnte nicht erfolgreich hochgeladen werden.' + "\r\n\n" + reponse.Error.Message + "\r\n\n" + reponse.Error.InternalMessage).replaceAll("\n", "\n<br/>\r\n"));
        }
        else {
            //DrDocWeb.ModalOk('Upload Erfolgreich', 'Datei wurde erfolgreich hochgeladen.');

            let searchNewVersionObj = {
            };


            let uniqueIdFieldsArr = [DrDoc.ID_FIELD, 'DokuNr', idFieldName];

            for (let uniqueIdField of uniqueIdFieldsArr) {
                if (!DrDocWeb.IsNullOrEmpty(uniqueIdField))
                    searchNewVersionObj[uniqueIdField] = [];
            }

            let resultsArr = null;

            if (reponse.Result != undefined && reponse.Result != null) {
                if (Array.isArray(reponse.Result))
                    resultsArr = reponse.Result;
                else
                    resultsArr = [reponse.Result];

                resultsArr.forEach(function (obj) {
                    //console.log('DrDoc.UploadDocument: ret: ', obj['DrDocGUID'], obj[DrDoc.ID_FIELD], obj['DokuNr']);
                    //searchNewVersionObj['DrDocGUID'].push(obj['DrDocGUID']);
                    if (!DrDocWeb.IsNullOrEmpty(obj['DokuNr']) && searchNewVersionObj['DokuNr'].indexOf(obj['DokuNr']) == -1)
                        searchNewVersionObj['DokuNr'].push(obj['DokuNr']);
                    else if (!DrDocWeb.IsNullOrEmpty(obj[DrDoc.ID_FIELD]) && searchNewVersionObj[DrDoc.ID_FIELD].indexOf(obj[DrDoc.ID_FIELD]) == -1)
                        searchNewVersionObj[DrDoc.ID_FIELD].push(obj[DrDoc.ID_FIELD]);

                    for (let uniqueIdField of uniqueIdFieldsArr) {
                        if (!DrDocWeb.IsNullOrEmpty(uniqueIdField) && !DrDocWeb.IsNullOrEmpty(obj[uniqueIdField]) && searchNewVersionObj[uniqueIdField].indexOf(obj[uniqueIdField]) == -1) {
                            searchNewVersionObj[uniqueIdField].push(obj[uniqueIdField]);
                            break;
                        }
                    }

                    if (!DrDocWeb.IsNullOrEmpty(obj.$ModelType)) {
                        console.log('DrDoc.UploadDocument: Change Archive: ', obj.$ModelType);
                        archiveName = obj.$ModelType;
                    }

                });
            }

            for (let propName in searchNewVersionObj) {
                searchNewVersionObj[propName] = searchNewVersionObj[propName].join('|');
            }

            //console.log('DrDoc.UploadDocument: SearchFields: in ', archiveName, ' / ', searchNewVersionObj);
            //console.log('DrDoc.UploadDocument: SearchFields: in ', archiveName, ' / ', searchNewVersionObj, ' / reponse.Result: ', resultsArr, ' / reponse.Result.length: ', resultsArr.length, ' / getDocument: ', getDocument, ' / ', reponse.Result != undefined && reponse.Result != null && reponse.Result.length == 1);

            if ((getDocument > 0 || getDocument === true) && resultsArr != undefined && resultsArr != null && resultsArr.length == 1) {
                for (let uniqueIdField of uniqueIdFieldsArr) {
                    if (!DrDocWeb.IsNullOrEmpty(uniqueIdField) && !DrDocWeb.IsNullOrEmpty(searchNewVersionObj[uniqueIdField])) {
                        if (getDocument === true || getDocument === 1) {
                            return DrDoc.MaskShowDocumentByField(sourceElement, archiveName, uniqueIdField, searchNewVersionObj[uniqueIdField]);
                        }
                        else // if(..)
                        {
                            let url = DrDoc.MaskGetDocumentUrlByField(archiveName, uniqueIdField, searchNewVersionObj[uniqueIdField]);
                            window.location.href = url;
                            return true;
                        }
                    }
                }
            }

            return DrDoc.SearchFields(sourceElement, archiveName, searchNewVersionObj, false);

            //DrDoc.GetDataset(elem, archiveName, documentIdField, documentId, 'lock');
        }
    })
        .catch(function (reponse_Str) {
            if (stateModal)
                stateModal.close();
            console.error(reponse_Str);
            let reponse = DrDocWeb.JsonToObject(reponse_Str);
            DrDocWeb.ModalError('Upload Fehler', ('Datei konnte nicht erfolgreich hochgeladen werden.' + (reponse && reponse.Error ? ("\r\n\n" + reponse.Error.Message + "\r\n\n" + reponse.Error.InternalMessage) : '')).replaceAll("\n", "\n<br/>\r\n"));
        });
};

// --
// Desktop

DrDoc.DesktopAction = function (sourceElement, xmlStr) {
    if (typeof sourceElement === 'string')
        sourceElement = Node.GetElement(sourceElement);

    //xmlStr = xmlStr.replaceAll('\\', '&#92;');
    //console.log('DrDoc.DesktopAction: ', xmlStr);
    const parser = new DOMParser();
    const doc = parser.parseFromString(xmlStr, "text/xml"); // text/xml application/xml
    //console.log('Desktop 1: ', doc, xmlStr, ' / Src: ', sourceElement);

    let xPathPrefix = 'DesktopSymbol>';

    let treeItemTyp = doc.querySelector(xPathPrefix + 'TreeItemTyp').innerHTML;
    //console.log(treeItemTyp);

    let archiveName = 'LEER';
    let archiveNameNode = doc.querySelector(xPathPrefix + 'ArchivPfad');
    if (archiveNameNode != null)
        archiveName = DrDoc.GetSimpleArchiveName(archiveNameNode.innerHTML);

    //console.log(doc, ' / Archive-Path: ', archiveName, ' / Archive-Node: ', archiveNameNode, ' / Src: ', sourceElement);
    //console.log('Desktop 2: ', doc, ' / Archive-Path: ', archiveName, ' / Src: ', sourceElement);

    switch (treeItemTyp) {
        case '1':
            break;

        // Archiv wählen
        case '2':
            DrDoc.configDevice.set('view/selected-archive', archiveName);
            break;

        // Volltextsuche
        case '3':
            let searchText = window.prompt('Volltextsuche in "' + DrDoc.GetArchiveLabel(archiveName, archiveName) + '"');
            if (!DrDocWeb.IsNullOrEmpty(searchText)) {
                DrDoc.SearchText(sourceElement, archiveName, searchText);
            }
            break;

        // Feldsuche
        case '4':
            DrDoc.SearchFieldsForm(sourceElement, archiveName);
            break;

        // Suchvorlage / Feldsuche mit Vorlage
        case '5':
            let searchTemplateNode = doc.querySelector(xPathPrefix + 'Suchvorlage');
            if (searchTemplateNode)
                DrDoc.SearchTemplate(sourceElement, archiveName, searchTemplateNode.innerHTML);
            else
                DrDoc.SearchTemplateForm(sourceElement, null);
            break;

        // Datensatz erstellen
        case '6':
            // Feldvorbelegung
            DrDoc.CreateDatasetForm(sourceElement, archiveName, null, doc.querySelector(xPathPrefix + 'Feldvorbelegung').innerHTML);
            break;

        // Neueingebe, Datensatz erstellen
        case '7':
            // Feldvorbelegung
            DrDoc.CreateDatasetForm(sourceElement, archiveName, null, doc.querySelector(xPathPrefix + 'Feldvorbelegung').innerHTML);
            break;

        // Scan erstellen als Dok. Definition
        case '8':
            // Feldvorbelegung
            // ScanjobNr
            DrDoc.CreateDatasetForm(sourceElement, archiveName, null, doc.querySelector(xPathPrefix + 'Feldvorbelegung').innerHTML);
            break;

        // Neues Dokument
        case '9':
            // Feldvorbelegung
            // ScanjobNr
            DrDoc.CreateDatasetForm(sourceElement, archiveName, null, doc.querySelector(xPathPrefix + 'Feldvorbelegung').innerHTML);
            break;

        // Hypersuche Volltext
        case '19':
            let searchTextHyper = window.prompt('Hyper-Volltextsuche in allen Archiven');
            if (!DrDocWeb.IsNullOrEmpty(searchTextHyper)) {
                DrDoc.SearchHyper(sourceElement, archiveName, '', searchTextHyper, 'Hyper-Volltextsuche in allen Archiven');
            }
            break;

        // Workflow Instanz erstellen
        case '12':
            // WfTyp
            // OrgGuid
            DrDocWeb.ModalInfo('Desktop Type 12/WF-Instance not implemented yet.');
            break;

        // Export
        case '29':
            // Suchvorlage
            // ReportExportInfo/VorlagenSuche
            // ReportExportInfo/FaExport
            // ReportExportInfo/ZielDateiName
            // ReportExportInfo/DokExport
            // ReportExportInfo/EinzelDateien
            // ReportExportInfo/Ascii
            // ReportExportInfo/FeldTrenner
            // ReportExportInfo/SatzTrenner
            // ReportExportInfo/AbsatzMarke
            DrDocWeb.ModalInfo('Desktop Type 29/Export-Def. not implemented yet.');
            break;

        default:
            DrDocWeb.ModalInfo('Desktop Type ' + treeItemTyp + ' not implemented yet.');
            break;

        /*
        DrDoc.SearchHyper = function (sourceElement, archiveName, hyperName, hyperSearchText, title
        DrDoc.SearchFields(sourceElement, archiveName)
        DrDoc.CreateDatasetForm = function (sourceElement, archiveName, data, presetName, newWindow)
        DrDoc.SearchFieldsForm = function (sourceElement, archiveName
        DrDoc.SearchTemplateForm = function (sourceElement, archiveName)
        DrDoc.SearchTemplate = function (sourceElement, archiveName, templateName)
        DrDoc.SearchText = function (sourceElement, archiveName, searchText)
        */
    }
    DrDocWeb.ModalClose(sourceElement);
};

// --

DrDoc.Client = function (obj) {
    /*let cookie_obj = {
        action: 'cookie'
    };*/

    obj['server-url'] = DrDocWeb.ServerBase();
    obj['cookie-names'] = [];
    obj['cookie-values'] = [];

    var cookie_prefix_arr = DrDocWeb.GetCookiePrefix('uid_');
    if (cookie_prefix_arr != undefined && cookie_prefix_arr.length > 0) {
        for (let cookie of cookie_prefix_arr) {
            obj['cookie-names'].push(cookie.name);
            obj['cookie-values'].push(cookie.value);

            /*cookie_obj['name'] = cookie.name;
            cookie_obj['value'] = cookie.value;
            console.log('DrDoc.Client: ', cookie_obj);
            DrDoc.ClientInternal(cookie_obj);*/
        }
    }

    let uid_value = DrDocWeb.GetCookie('uid');
    if (!DrDocWeb.IsNullOrEmpty(uid_value)) {
        obj['cookie-names'].push('uid');
        obj['cookie-values'].push(uid_value);

        /*cookie_obj['name'] = 'uid';
        cookie_obj['value'] = uid_value;
        console.log('DrDoc.Client: ', cookie_obj);
        DrDoc.ClientInternal(cookie_obj);*/
    }
    obj['cookie-names'] = obj['cookie-names'].join(';');
    obj['cookie-values'] = obj['cookie-values'].join(';');
    console.log('DrDoc.Client: ', obj['cookie-names'], obj['cookie-values']);

    DrDoc.ClientInternal(obj);
};

DrDoc.ClientInternal = function (obj) {
    window.open('drdoc://' + DrDocWeb.ObjectToQueryStr(obj), '_blank');
};

// --

DrDoc.OpenPDF = function (pdfjsLib, url, canvasElem) {
    // If absolute URL from the remote server is provided, configure the CORS
    // header on that server.
    //var url = '{{$_this.Url(false, false)}}';

    // Loaded via <script> tag, create shortcut to access PDF.js exports.
    //var { pdfjsLib } = globalThis;

    // The workerSrc property shall be specified.
    //pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.mjs';

    // Asynchronous download of PDF
    var loadingTask = pdfjsLib.getDocument(url);
    loadingTask.promise.then(function (pdf) {
        console.log('PDF loaded');

        // Fetch the first page
        var pageNumber = 1;
        pdf.getPage(pageNumber).then(function (page) {
            console.log('Page loaded');

            var scale = 1.5;
            var viewport = page.getViewport({ scale: scale });

            // Prepare canvas using PDF page dimensions
            var canvas = canvasElem; //document.getElementById('the-canvas');
            var context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            // Render PDF page into canvas context
            var renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            var renderTask = page.render(renderContext);
            renderTask.promise.then(function () {
                console.log('Page rendered');
            });
        });
    }, function (reason) {
        // PDF loading error
        console.error(reason);
    });
};

// --

// Datensatz in Suchergebnisliste Drag n droppen unter Anwednung der Sortierung
DrDoc.ListDragAndDropDataset = function (name, e, archiveName) //, sortField, sortFieldSub) //, documentId)
{
    archiveName = DrDoc.GetSimpleArchiveName(archiveName);
    //console.log('DrDoc.DragAndDropDataset: ', name, archiveName);
    let elemTarget = DrDocWeb.dnd_getElem(name, e.target);
    if (elemTarget == null || elemTarget == undefined)
        return;
    let elemPrev = elemTarget.previousElementSibling;
    let elemNext = elemTarget.nextElementSibling;

    //DrDoc.DatasetListSelectItem(elemTarget, archiveName, documentId);

    let documentId = DrDoc.GetListDatasetID(elemTarget);
    let elemPrevNodeId = '';
    let elemNextNodeId = '';

    // Beim Drag and Drop eines Datensatzes immer "sortFieldSub" wählen,
    // wenn alle Elemente in der gleichen Liste sind also den selben parentNode haben.
    //let selectedSortFieldName = sortField;
    let selectedSortFieldNames = DrDocWeb.dnd_getValue(elemTarget);
    //console.log('DrDoc.ListDragAndDropDataset: Sort by: ', selectedSortFieldNames);

    if (elemPrev != undefined && elemPrev != null) {
        let elemPrevNodeIdArr = Node.GetNodeId(elemPrev).split('|');
        elemPrevNodeId = elemPrevNodeIdArr[elemPrevNodeIdArr.length - 1];
    }
    if (elemNext != undefined && elemNext != null) {
        let elemNextNodeIdArr = Node.GetNodeId(elemNext).split('|');
        elemNextNodeId = elemNextNodeIdArr[elemNextNodeIdArr.length - 1];
    }

    //let searchTemplateName2 = DrDoc.GetListTemplateName(elemTarget);

    return window.Node.LoadComponent({
        title: 'DragAndDropDataset ' + DrDoc.GetArchiveLabel(archiveName),
        sourceElement: elemTarget,
        targetElement: elemTarget, //DrDoc.GetListNodeId(elemTarget, archiveName, false),
        getData: {
            archive: archiveName,
            mode: 'dragndrop',
            id: documentId,
            id_prev: elemPrevNodeId,
            id_next: elemNextNodeId,
            sort_fields: selectedSortFieldNames,
            searchTemplateName: DrDoc.GetSearchTemplate(rowElem, archiveName),
            selection: DrDoc.GetSearchFieldSelection(rowElem, archiveName),
            //tree: false,
            //'tree-sub': false,
        },
        //postData: { }
    }).then(data => {
        //DrDoc.UpdateDatasetRow(elemTarget, archiveName, documentId)
        DrDoc.DatasetSelected(elemTarget, archiveName, '', documentId, 'get');
    });

};

// --

DrDoc.ListSet = function (archiveName, array) {
    DrDoc._datasetList[archiveName] = array;
    console.log('DrDoc.ListSet', DrDoc._datasetList);
};
DrDoc.ListGet = function (archiveName) {
    return DrDoc._datasetList[archiveName];
};
DrDoc.ListIndexOf = function (archiveName, id) {
    let list = DrDoc.ListGet(archiveName);
    return list.indexOf(id);
};
DrDoc.DatasetListUnselectItem = function (sourceElement, archiveName) {
    if (typeof sourceElement === 'string')
        sourceElement = Node.GetElement(sourceElement);

    var tableNodeElem = DrDoc.GetTableNodeElement(sourceElement, archiveName);
    if (tableNodeElem !== undefined && tableNodeElem !== null)
        sourceElement = tableNodeElem;

    var old_table_row = DrDocWeb.GetElement(sourceElement, 'tr.table-active');
    if (old_table_row != undefined) {
        old_table_row.classList.remove('table-active');
        old_table_row.classList.remove('table-dark');
        old_table_row.classList.remove('bg-primary');
        old_table_row.classList.remove('text-light');
    }
};

DrDoc.DatasetListSelectItem = function (sourceElement, archiveName, documentId) {
    if (typeof sourceElement === 'string')
        sourceElement = Node.GetElement(sourceElement);

    if (sourceElement === undefined || sourceElement === window || sourceElement === document) {
        console.warn('DatasetListSelectItem: bad source element');
        return;
    }

    // --

    // Layout automatisch setzen je nach endgerät
    //DrDoc.SetViewDataset();

    /*var old_table_row = DrDocWeb.GetElement(sourceElement, 'tr.table-active');
    if (old_table_row != undefined) {
        old_table_row.classList.remove('table-active');
        old_table_row.classList.remove('table-dark');
        //old_table_row.classList.remove('bg-secondary');
        old_table_row.classList.remove('bg-primary');
        old_table_row.classList.remove('text-light');
    }*/
    DrDoc.DatasetListUnselectItem(sourceElement, archiveName);

    let selectedSearchTemplate = DrDoc.GetSearchTemplate(sourceElement, archiveName);

    //var row = DrDoc.GetTableRowElementByID(document, archiveName, documentId);
    var row = DrDoc.GetTableRowElementByID(sourceElement, archiveName, documentId);
    //var row = sourceElement;
    //var row = DrDocWeb.GetElement(sourceElement, 'tr');
    // sourceElement.tagName == 'TR' ? sourceElement : DrDoc.GetTableRowElementByID(sourceElement, archiveName, documentId);
    if (row === undefined || row === null) {
        console.warn('DatasetListSelectItem: Row Element nicht gefunden!', ' / archiveName:', archiveName, ' / selectedSearchTemplate:', selectedSearchTemplate, ' / documentId:', documentId, sourceElement);
        return;
    }
    else {
        row.classList.add('table-active');
        row.classList.add('table-dark');
        //row.classList.add('bg-secondary');
        row.classList.add('bg-primary');
        row.classList.add('text-light');
        //console.log('DatasetSelected: ', sourceElement, row, documentId);
        //sourceElement = row;
    }
    return row;
};

DrDoc.DatasetSelected = function (sourceElement, archiveName, documentIdField, documentId, mode, sourceObjStr) //, source_archiveName, source_fieldName, source_row, sourceObjStr)
{
    if (typeof sourceElement === 'string')
        sourceElement = Node.GetElement(sourceElement);
    //DrDoc._datasetIndex[archiveName] = DrDoc.ListIndexOf(archiveName, documentId);

    //DrDoc.UnlockOnlyDataset(sourceElement, archiveName, documentId);

    if (sourceElement === undefined || sourceElement === window || sourceElement === document) {
        console.warn('DatasetSelected: bad source element');
        return;
    }

    // --

    let sourceArchiveName = archiveName;
    let source_obj = null;
    if (DrDocWeb.IsNullOrEmpty(sourceObjStr)) {
        //console.error('Thesaurus hat keinen Mode angegeben! ', this);
        //source_mode = mode;
    }
    else {
        if (typeof sourceObjStr === 'string') {
            var source_decoded = decodeURIComponent(sourceObjStr);
            source_obj = DrDocWeb.JsonToObject(source_decoded);
        }
        else {
            source_obj = sourceObjStr;
        }
        sourceArchiveName = source_obj.archive;
    }

    // --

    // Layout automatisch setzen je nach endgerät
    DrDoc.SetViewDataset();

    let row = DrDoc.DatasetListSelectItem(sourceElement, sourceArchiveName, documentId)
    if (row == undefined || row == null)
        return;

    // --

    //console.log('DatasetSelected: ', table);

    //console.log('DatasetSelected (1): ', archiveName, sourceArchiveName, documentId, mode);

    // Mode bezieht sich auf die Liste
    if (mode === 'get' || mode === 'info' || mode === 'searchfields' || mode === 'textretrieval' || mode === 'template' || mode === 'event' || mode === 'hyper' || mode === 'tmp' || mode === 'tmp-delete-last') {
        if (mode === 'info')
            DrDocWeb.ModalClose(sourceElement);
        //console.log('DatasetSelected: GET / ', sourceElement, archiveName, documentId, 'get');
        //if (prompt('ok?', true))
        //{

        DrDoc.GetSearchTemplate(sourceElement, archiveName);

        return DrDoc.GetDataset(sourceElement, archiveName, documentIdField, documentId, 'get').then(function (x) {

            //DrDoc.configDevice.update('view/list-width');
            //DrDoc.configDevice.set('view/list-width', DrDoc.configDevice.get('view/list-width')+0.1);
            DrDoc.UpdateSplitPanel();
            //console.log('Mask Update List W: ',  DrDoc.configDevice.has('view/list-width'), DrDoc.configDevice.get('view/list-width', 50));
            DrDoc.configDevice.set('view/selected-archive', archiveName);
        });
        //}
    }
    else if (mode === 'thes') {
        // aus Ziel in Maske Daten importieren!
        //alert('Thes. not implemented yet.');

        // return DrDoc.GetDataset(sourceElement, archiveName, documentIdField, documentId, 'thes');

        if (source_obj == undefined || source_obj == null) {
            console.error('Thesaurus hat keinen Mode angegeben! ', this);
            //source_mode = mode;
            return;
        }
        //console.log('DatasetSelected (2.1): Thes/Zusatzinfo Source Obj', source_obj, archiveName, sourceArchiveName);

        // Thes
        source_obj.thes = true;
        source_obj.thes_id = DrDocWeb.IsNullOrEmpty(documentId) ? '' : documentId;

        // Node.GetElement
        let nodeId = DrDoc.GetMaskNodeId(sourceElement, sourceArchiveName);
        let elem = Node.GetElement(nodeId);

        /*if (elem == undefined || elem == null) {
            nodeId = 'system/list|content|' + archiveName + '|dataset';
            elem = Node.GetElement(nodeId);
        }*/

        //console.log('DatasetSelected (2.2):', nodeId, elem, sourceArchiveName);

        let res = DrDocWeb.ModalClose(sourceElement);

        return window.Node.LoadComponent({
            title: 'Thesaurus im Archiv ' + DrDoc.GetArchiveLabel(archiveName),
            sourceElement: elem,
            targetElement: nodeId,
            getData: source_obj,
        }).then(data => {
            //let res = DrDocWeb.ModalClose(sourceElement);
            // wieder zum Quellarchiv zurückwechseln
            DrDoc.configDevice.set('view/selected-archive', sourceArchiveName);
        });
    }
    else {
        alert('Bad Mode ' + mode);
        console.warn('Bad Mode', mode);
    }
};

// DOM Node für Listen
DrDoc.GetTableNodeElement = function (sourceElement, archiveName, newWindow) {

    //var elem = null;
    /*if (newWindow === true) // || sourceElement == undefined || sourceElement == null)
    {
        //elem = Node.GetElement('system/list-info|content');
        //if (elem != null 
        return 'system/list-info|content';
    }*/

    return DrDoc.GetTableRowElementByIDInternal(sourceElement, archiveName, false, undefined);
};
DrDoc.GetTableRowElementByID = function (sourceElement, archiveName, documentId) {
    return DrDoc.GetTableRowElementByIDInternal(sourceElement, archiveName, true, documentId);
};
/*DrDoc.GetTableElement = function (sourceElement, archiveName) {
    return DrDocWeb.GetElement(DrDoc.GetTableNodeElement(sourceElement), 'table.list-datasets');
};*/
DrDoc.__GetTableRowElementByID = function (sourceElement, archiveName, documentId) {
    var table = DrDoc.GetTableNodeElement(sourceElement, archiveName);
    if (table == undefined || table === null) {
        console.warn('DrDoc.GetTableRowElementByID: ', sourceElement, archiveName, documentId);
        return undefined;
    }
    let tableNodeId = Node.GetNodeId(table);
    let nodeId = '';
    let elem = null;

    nodeId = tableNodeId + '|' + documentId;
    elem = Node.GetElement(nodeId, table);

    /*if (elem == undefined || elem == null) {
        nodeId = tableNodeId + '|_DEFAULT_|' + documentId;
        elem = Node.GetElement(nodeId, table);
    }
    if (elem == undefined || elem == null) {
        nodeId = tableNodeId + '|' + DrDoc.configDevice.get('view/list/' + archiveName + '/selected-searchtemplate') + '|' + documentId;
        elem = Node.GetElement(nodeId, table);
    }
    if (elem == undefined || elem == null) {
        nodeId = tableNodeId + '|' + documentId;
        elem = Node.GetElement(nodeId, table);
    }*/

    /*if (elem == undefined || elem == null)
    {
        nodeId = Node.GetNodeId(sourceElement) + '|_DEFAULT_|' + documentId;
        elem = Node.GetElement(nodeId, sourceElement);
    }
    if (elem == undefined || elem == null)
    {
        nodeId = Node.GetNodeId(sourceElement) + '|' + documentId;
        elem = Node.GetElement(nodeId, sourceElement);
    }*/

    if (elem == undefined || elem == null) {
        console.warn('DrDoc.GetTableRowElementByID: Table found, but Elem/Row Not found! / documentId:', documentId, ' / NodeId: ', nodeId, ' / Table Node Id: ', tableNodeId, ' / Table: ', table);
        return undefined;
    }
    //console.log('DrDoc.GetTableRowElementByID', nodeId, elem); //, table);
    return elem;
};

//DrDoc.OnSelectRowElementRel = 
DrDoc.OnSelectDatasetRel = function (sourceElement, archiveName, documentIdField, documentId, rel) {
    if (typeof sourceElement === 'string')
        sourceElement = Node.GetElement(sourceElement);
    //var table = DrDoc.GetTableElement(sourceElement, archiveName);
    /*var tableNodeElem = DrDoc.GetTableNodeElement(sourceElement, archiveName);
    if (tableNodeElem === undefined || tableNodeElem === null) {
        console.warn('OnSelectRowElementRel: Table Element nicht gefunden!', sourceElement, archiveName, documentId, rel);
        return undefined;
    }
    var tbody = DrDocWeb.GetElement(tableNodeElem, 'table.list-datasets tbody');*/

    var row = DrDoc.GetTableRowElementByID(sourceElement, archiveName, documentId);
    if (row === undefined || row === null) {
        console.warn('OnSelectRowElementRel: Row Element nicht gefunden!', sourceElement, archiveName, documentId, rel);
        return undefined;
    }
    var tbody = DrDocWeb.GetElement(row, 'tbody', -1);
    /*var tbody = null;
    while (row.parentNode != null)
    {
        tbody = row.parentNode;
        if (tbody.tagName == 'TBODY')
            break;
    }*/
    //var tbody = table.getElementsByTagName('tbody')[0]; // table.tbody; //
    //console.log('OnSelectRowElementRel -> IST', sourceElement, tbody.children, table, row);
    //console.log('OnSelectRowElementRel -> IST', ' / sourceElement: ', sourceElement, ' / tbody: ', tbody, ' / row: ', row);

    if (row !== undefined && row !== null) {
        //row.removeClass('table-active');
        //int i = table.tbody.childNodes.indexOf(row);
        // table.children.indexOf(row);
        // Index der Row herausfinden
        var i = Array.prototype.indexOf.call(tbody.children, row);
        var i_selected = i + rel;
        if (i !== -1 && i_selected >= 0 && i_selected < tbody.children.length) {
            var row_selected = tbody.children[i_selected];
            //documentId = document.querySelector(tbody.children[i]).attr('data-id');
            let documentId_selected = DrDoc.GetListDatasetID(row_selected);
            //console.log('OnSelectRowElementRel -> SOLL Selected ID: ', documentId_selected, '  Elem: ', row_selected);

            //action(row_selected, documentId_selected);
            //return true;
            return DrDoc.DatasetSelected(row_selected, archiveName, documentIdField, documentId_selected, 'get');
        }
        else {
            console.log('OnSelectRowElementRel, bad index : ', i, sourceElement, archiveName, documentId, rel, tbody, tbody.children, row); //, Node.GetNodeId(tableNodeElem), tableNodeElem);
            return undefined;
        }
    }
    return undefined;
};
DrDoc.OnSelectPrevDataset = function (sourceElement, archiveName, documentIdField, documentId) {
    return DrDoc.OnSelectDatasetRel(sourceElement, archiveName, documentIdField, documentId, -1);
};
DrDoc.OnSelectNextDataset = function (sourceElement, archiveName, documentIdField, documentId) {
    return DrDoc.OnSelectDatasetRel(sourceElement, archiveName, documentIdField, documentId, 1);
};
DrDoc.RegisterShortcuts = function (archiveName, shortcuts) {

};


DrDoc.TableRemoveRow = function (rowElem) {
    // Tabellen-Zeile nicht entfernen, sondern nur leeren und ausblenden, sonst funktioniert der Row-Index nicht mehr (z.B. für Thesaurus)!
    //rowElem.parentNode.removeChild(rowElem);
    var inputElems = rowElem.querySelectorAll('input');
    //console.log('DrDoc.TableRemoveRow: ', inputElems);
    if (inputElems) {
        inputElems.forEach(function (inputElem) {
            inputElem.value = '';
            inputElem.innerHTML = '';
            inputElem.checked = undefined;
            inputElem.required = false;
            //console.log('DrDoc.TableRemoveRow - Cell Input: ', inputElem.value, inputElem);
        });
    }

    inputElems = rowElem.querySelectorAll('textarea');
    if (inputElems) {
        inputElems.forEach(function (inputElem) {
            inputElem.value = '';
            inputElem.innerHTML = '';
            inputElem.checked = undefined;
            inputElem.required = false;
        });
    }

    inputElems = rowElem.querySelectorAll('textarea');
    if (inputElems) {
        inputElems.forEach(function (inputElem) {
            inputElem.value = '';
            inputElem.innerHTML = '';
            inputElem.checked = undefined;
            inputElem.required = false;
        });
    }

    rowElem.style.display = 'none';
};


DrDoc.TableOpenModal = function (sourceElement, title) {
    if (!sourceElement || !sourceElement.parentNode)
        return;

    let tmp_top = sourceElement.style.top;
    let tmp_left = sourceElement.style.left;
    let tmp_width = sourceElement.style.width;
    let tmp_height = sourceElement.style.height;
    let tmp_position = sourceElement.style.position;

    sourceElement.style.top = '';
    sourceElement.style.left = '';
    sourceElement.style.width = '100%';
    sourceElement.style.height = '100%';
    sourceElement.style.position = 'relative';

    // Placeholder erstellen und mit Tabelle mit Placeholder ersetzen
    let elemPlaceholder = document.createElement('div');
    elemPlaceholder.innerText = 'PLACEHOLDER';
    sourceElement.parentNode.insertBefore(elemPlaceholder, sourceElement);

    // Element aus Maske holen und im Modal einbinden
    sourceElement.parentNode.removeChild(sourceElement);
    let modal = DrDocWeb.Modal(title, sourceElement, {
        //color: 'danger',
        fullScreen: true,
        size: 'lg'
    });

    //console.log('DrDoc.TableOpenModal: ', modal);

    // beim Schließen des Modal Tabelle aus dem Modal wieder in die Maske setzen
    modal._element.addEventListener('hidden.bs.modal', function (event) {
        //console.log('DrDoc.TableOpenModal: hidden.bs.modal');
        elemPlaceholder.parentNode.replaceChild(sourceElement, elemPlaceholder);

        // Styles zurücksetzen
        sourceElement.style.top = tmp_top;
        sourceElement.style.left = tmp_left;
        sourceElement.style.width = tmp_width;
        sourceElement.style.height = tmp_height;
        sourceElement.style.position = tmp_position;
    });
};

// Anzahl der Datensatz-Treffer in ein DOM Element laden
// Suche nach Attributen [data-search-archive] und [data-search-template] oder [data-search-hyper]
DrDoc.SearchCountElement = function (elem) {
    if (!DrDocWeb.IsNullOrEmpty(elem) && typeof elem === 'string')
        elem = Node.GetElement(elem);
    if (elem == undefined || elem == null)
        elem = document;

    let crudAction = function (counterElem) {
        //counterElem.innerText = '..';
        counterElem.innerHtml = `<div class="spinner-border text-danger" role="status">
  <span class="visually-hidden">...</span>
</div>`;
        counterElem.parentNode.style.position = 'relative'; // !important';
        counterElem.style.position = 'absolute'; // !important';
        
        //counterElem.style.top = 'min(15%, 12px)'; //!important';
        //counterElem.style.left = 'min(85%, 12px)'; //!important';
        //counterElem.style.transform = 'translate(-50%,-50%)'; //!important';
        
        counterElem.style.top = '0px';
        counterElem.style.right = '0px';
        counterElem.style.transform = 'translate(0%,-45%)';
        //counterElem.style.transform = 'translate(0%,-0.5rem)';

        //counterElem.className = 'position-absolute top-0 start-100 translate-middle badge rounded-pill bg-secondary';
        return function (dataArr, dataObj) {
            // dataObj = { Count, CountTotal, SortTree }
            console.log(this, counterElem, dataArr, dataObj, dataObj.CountTotal);
            counterElem.innerHtml = '';
            if (dataObj.CountTotal !== undefined && dataObj.CountTotal > 0) {
                if (dataObj.CountTotal > 500)
                    counterElem.classList.add('bg-danger');
                else if (dataObj.CountTotal > 100)
                    counterElem.classList.add('bg-warning');
                else
                    counterElem.classList.add('bg-secondary');
                counterElem.classList.add('badge');
                counterElem.innerText = dataObj.CountTotal;
            }
            else {
                counterElem.classList.add('bg-success');
                counterElem.classList.add('badge');
                counterElem.innerText = '0';
            }
        };
    };

    let loadDsCountElems1 = elem.querySelectorAll('[data-search-template]');
    if (loadDsCountElems1 != null) {
        for (let loadDsCountElem of loadDsCountElems1) {
            let archiveName = loadDsCountElem.getAttribute('data-search-archive');
            let searchTemplateName = loadDsCountElem.getAttribute('data-search-template');

            if (DrDocWeb.IsNullOrEmpty(archiveName))
                continue;
            if (DrDocWeb.IsNullOrEmpty(searchTemplateName))
                continue;

            //console.log('Search Template: ', archiveName, searchTemplateName, loadDsCountElem);

            let getObj = {
                action: 'template',
                archive: archiveName,
                value: searchTemplateName,
                count: 0,
                max: -1
            };

            Dataset.Crud(getObj, crudAction(loadDsCountElem));
        }
    }

    let loadDsCountElems2 = elem.querySelectorAll('[data-search-hyper]');
    if (loadDsCountElems2 != null) {
        for (let loadDsCountElem of loadDsCountElems2) {
            let archiveName = loadDsCountElem.getAttribute('data-search-archive');
            let searchHyperName = loadDsCountElem.getAttribute('data-search-hyper');

            if (DrDocWeb.IsNullOrEmpty(searchHyperName))
                continue;

            //console.log('Search Hyper: ', archiveName, searchHyperName, loadDsCountElem);

            let getObj = {
                action: 'hyper',
                archive: archiveName,
                value: searchHyperName,
                count: 0,
                max: -1
            };

            Dataset.Crud(getObj, crudAction(loadDsCountElem));
        }
    }
};


// ---
// User Data

/*DrDoc.SelectedArchiveName = '';
DrDoc.SetSelectedArchive = function(selectedArchiveName) {
    
    DrDoc.SelectedArchiveName = selectedArchiveName;
    DrDoc.ConfSet('view/selected-archive', selectedArchiveName);
};*/
//DrDoc.configUser.subscribeBool('view/select-archive', false);
//DrDoc.configUser.subscribeBool('view/select-archive');
DrDoc.GetSelectedArchive = function (callback) {
    if (typeof callback !== 'function') {
        console.warn('GetSelectedArchive', 'Funktion muss als Argument ein Callback übergeben!');
        return undefined;
    }

    let isSelectArchive = DrDoc.configUser.get('view/select-archive', false);
    console.log('view/select-archive', isSelectArchive);
    let archiveName = DrDoc.configUser.get('view/selected-archive');

    //let hasSelectedArchive = DrDoc.SelectedArchiveName !== undefined && DrDoc.SelectedArchiveName !== null && DrDoc.SelectedArchiveName.length > 0;
    let hasSelectedArchive = DrDoc.configUser.has('view/selected-archive');

    if (isSelectArchive === false && hasSelectedArchive) {
        callback(archiveName);
    }
    else {
        let modalSrc = '<div class="list-group">';
        let archives = DrDoc.GetUserData().Result.Archives;
        for (let i in archives) {
            // DrDocWeb.ModalClose(this); 
            modalSrc += `<button class="list-group-item list-group-item-action ${archives[i].Archive.SimpleName === archiveName ? 'active' : ''}" onclick="DrDocWeb.ModalGet(this).callback('${archives[i].Archive.SimpleName}'); ">${archives[i].Label}</button>`;
        }
        modalSrc += '</div>';

        let modal = DrDocWeb.Modal('Archiv wählen', modalSrc, { fullScreen: false });

        modal.callback = (selectedArchiveName) => {
            //DrDoc.SetSelectedArchive(selectedArchiveName);
            DrDoc.configUser.set('view/selected-archive', selectedArchiveName);
            modal.hide();
            callback(selectedArchiveName);
            //console.log('GetSelectedArchive (Callback)',  selectedArchiveName);
        };
        //console.log('GetSelectedArchive', modal, callback);
    }
};

DrDoc.GetUserData = function () {
    return DrDoc.store.get('userdata');
};

DrDoc.GetArchiveSession = function (archiveName) {
    if (DrDocWeb.IsNullOrEmpty(archiveName))
        return null;
    // ip\port\archive
    if (archiveName.indexOf('\\') > 0) {
        let archiveNameComponents = archiveName.split('\\');
        if (archiveNameComponents.length == 3 && DrDocWeb.ParseInt(archiveNameComponents[1]) > 0)
            archiveName = archiveNameComponents[2];
    }
    let userdata = DrDoc.GetUserData();
    if (userdata == null || userdata == undefined)
        return null;
    if (userdata.Result == null || userdata.Result == undefined)
        return null;
    let archives = userdata.Result.Archives;
    if (archives == null || archives == undefined)
        return null;
    for (let i in archives) {
        if (archives[i].Archive.SimpleName.toLowerCase() === archiveName.toLowerCase() || archives[i].Archive.FilenameServerDA.toLowerCase() === archiveName.toLowerCase() || archives[i].Archive.FilenameServerDA.toLowerCase() === archiveName.toLowerCase() + '.da')
            return archives[i];
    }
    return null;
};
DrDoc.GetArchiveLabel = function (archiveName, defaultLabel) {
    let session = DrDoc.GetArchiveSession(archiveName);
    if (session == null)
        return defaultLabel === undefined ? archiveName : defaultLabel;
    return session.Label;
}
DrDoc.GetArchive = function (archiveName) {
    let archObj = DrDoc.GetArchiveSession(archiveName);
    if (archObj != undefined && archObj != null)
        return archObj.Archive;
    return null;
};
DrDoc.GetSimpleArchiveName = function (archiveName) {
    let archObj = DrDoc.GetArchive(archiveName);
    if (archObj != undefined && archObj != null)
        return archObj.SimpleName;
    console.warn('DrDoc.GetSimpleArchiveName Archive Name not found: ', archiveName);
    return archiveName;
};
DrDoc.GetField = function (archiveName, fieldName) {
    let archive = DrDoc.GetArchive(archiveName);
    if (archive == null)
        return null;
    if (DrDocWeb.IsNullOrEmpty(fieldName))
        return null;
    let fields = archive.Fields;
    for (let i in fields) {
        if (fields[i].Name === fieldName)
            return fields[i];
    }
    return null;
};

DrDoc.TestUser = function (archiveName, fieldName) {
    console.log('Archive', DrDoc.GetArchive(archiveName));
    console.log('Archive Label', DrDoc.GetArchiveSession(archiveName).Label);
    console.log('Field', DrDoc.GetField(archiveName, DrDoc.ID_FIELD));
};

// --
// Split Panel

var _splitPanels = {};
DrDoc.SplitPanel = function (elemSelContaier, elemSel1, elemSel2, direction, size, onSizeChanged) {
    var obj = _splitPanels[elemSelContaier];

    if (size == null || size == undefined || isNaN(size))
        size = 35;
    size = Math.min(Math.max(size, 0), 100);

    if (direction == 'v' || direction == undefined || direction == null)
        direction = 'vertical';
    if (direction == 'h')
        direction = 'horizontal';

    // erst altes Objekt freigeben
    /*try
    {
        if (obj != null && obj != undefined) {
            obj.destroy();
            obj = null;
        }
    }
    catch(ex)
    {

    }*/

    var elemContainer = document.querySelector(elemSelContaier);
    var elemSplitter = document.querySelector(elemSelContaier + ' > .gutter');
    var elem1 = document.querySelector(elemSel1);
    var elem2 = document.querySelector(elemSel2);

    if (elemContainer == null || elemContainer == undefined) {
        return;
    }
    if (elem1 == null || elem1 == undefined) {
        return;
    }
    if (elem2 == null || elem2 == undefined) {
        return;
    }

    // --
    // bei 100% Splitter garnicht erst anwenden

    if (elemSplitter)
        elemSplitter.classList.remove('d-none');
    if (elem1)
        elem1.classList.remove('d-none');
    if (elem2)
        elem2.classList.remove('d-none');

    if (size >= 99) {
        if (elemSplitter)
            elemSplitter.classList.add('d-none');
        elem2.classList.add('d-none');
        //console.log('Split Hide 2: ', elem2, elemSplitter1, elemSplitter2);
        elem1.style.width = '100%';
        elem1.style.height = '100%';
        return;
    }
    else if (size < 1) {
        if (elemSplitter)
            elemSplitter.classList.add('d-none');
        elem1.classList.add('d-none');
        //console.log('Split Hide 1: ', elem1, elemSplitter1, elemSplitter2);
        elem2.style.width = '100%';
        elem2.style.height = '100%';
        return;
    }

    // --

    // Scroll Pos. merken
    var elem1_scrollTop = elem1.scrollTop;
    var elem1_scrollLeft = elem1.scrollLeft;

    var elem2_scrollTop = elem2.scrollTop;
    var elem2_scrollLeft = elem2.scrollLeft;

    //if (obj)
    //console.log('DrDoc.SplitPanel:  ', obj._elemContainer != elemContainer, obj._elem1 !== elem1, obj._elem2 !== elem2);

    if (obj == null || obj == undefined || obj._elemContainer != elemContainer || obj._elem1 !== elem1 || obj._elem2 !== elem2 || obj.splitObj.pairs[0].direction != direction)
    //if (obj == null || obj == undefined || obj.splitObj.pairs[0].direction != direction)
    {
        // => Split-Contaoner existiert noch nicht oder Richtung wurde geändert

        /*if (obj != undefined && obj._elemContainer !== elemContainer)
            console.warn('DrDoc.SplitPanel: Elem Container has Changed! ', elemSelContaier);
        if (obj != undefined && obj._elem1 !== elem1)
            console.warn('DrDoc.SplitPanel: Elem 1 has Changed! ', elem1);
        if (obj != undefined && obj._elem2 !== elem2)
            console.warn('DrDoc.SplitPanel: Elem 2 has Changed! ', elem2);*/

        if (elemContainer == null || elemContainer == undefined) {
            //console.log('SplitPanel: Element Container exisitert nicht! ', elemSelContaier);
            return;
        }
        if (elem1 == null || elem1 == undefined) {
            //console.log('SplitPanel: Element 1 exisitert nicht! ', elemSel1);
            return;
        }
        if (elem2 == null || elem2 == undefined) {
            //console.log('SplitPanel: Element 2 exisitert nicht! ', elemSel2);
            return;
        }

        // erst altes Objekt freigeben
        if (obj != null && obj != undefined && elem1.nextElementSibling != undefined && elem1.nextElementSibling != null && elem1.nextElementSibling.classList.contains('gutter') && obj.splitObj.pairs[0].direction == direction) {
            // bereits initialisiert, wenn gutter vorhanden
            //console.log('Split, bereits initialisiert', obj, elem1.nextElementSibling);

            var sizes = obj.splitObj.getSizes();
            if (sizes == null || sizes == undefined || (sizes.length > 0 && sizes[0] != size)) {
                obj.splitObj.setSizes([size, 100 - size]);
            }
        }
        else {
            //console.log('Split, neu initialisieren', obj); //, elem1.nextElementSibling);

            if (obj != null && obj != undefined) {
                try {
                    obj.splitObj.destroy(false, false);
                }
                catch (ex) {

                }
            }

            // https://split.js.org/#/?layout=float

            obj = {
                _elemContainer: elemContainer,
                splitObj: window.Split([elemSel1, elemSel2], {
                    sizes: [size, 100 - size],
                    minSize: [15, 15],
                    //expandToMin: true,
                    direction: direction,
                    onDragEnd: onSizeChanged,
                })
            };
        }
        _splitPanels[elemSelContaier] = obj;


        // Fallback
        elem1.style.display = 'block';
        elem1.style.float = 'left';

        elem2.style.display = 'block';
        elem2.style.float = 'left';


        // gutter.gutter-vertical: float: left + width: 100%;

        if (direction == 'vertical') {
            // vertical
            elemContainer.style.display = 'flex';
            elemContainer.style.flexDirection = 'column';
        }
        else {
            // horizontal
            elemContainer.style.display = 'flex';
            elemContainer.style.flexDirection = 'row';
        }

        // Scroll Pos. wiederherstellen
        elem1.scrollTop = elem1_scrollTop;
        elem1.scrollLeft = elem1_scrollLeft;

        elem2.scrollTop = elem2_scrollTop;
        elem2.scrollLeft = elem2_scrollLeft;
    }
    else {
        // => Split-Contaoner existiert bereits und Richtung wurde nicht geändert
        var sizes = obj.splitObj.getSizes();
        if (sizes == null || sizes == undefined || (sizes.length > 0 && sizes[0] != size)) {
            obj.splitObj.setSizes([size, 100 - size]);
        }
    }


    return obj;
};

DrDoc.HideSplitPanel = function () {
    if (false && DrDocWeb.IsMobile() && DrDoc.configUser.get('view/list/show-tree')) {
        DrDoc.configDevice.set('view/list-sort-width', 20);
    }
    DrDoc.configDevice.set('view/list-dataset-width', 100);
};
DrDoc.UpdateSplitPanel = function () {
    let mode = DrDoc.configDevice.get('view/layout-mode');
    let size_abs = DrDoc.configDevice.get('view/list-width');
};

/*
DrDoc.configDevice.subscribeInt('view/list-width', function (value, oldValue) {
    //console.log('subscribe: view/list-width: ', value, oldValue, ' / from cookie');
    
    //console.log('view/list-width: ', value, size_abs);
}, 50);

DrDoc.configDevice.subscribe('view/layout-mode', function (value, oldValue) {
    //console.log('subscribe: view/layout-mode: ', value, oldValue, ' / from cookie');
    if (DrDocWeb.IsNullOrEmpty(value))
        value = 'v';
    let size_abs = DrDoc.configDevice.get('view/list-width', 50);
    
}, 'v');*/

DrDoc.SetViewDataset = async function (archiveName) {
    console.log('DrDoc.SetViewDataset');
    //console.log('DrDoc.SetViewDataset');

    /*if (DrDocWeb.CheckRecursion())
    {
        console.warn('DrDoc.SetViewDataset(): RECUSION');
        return;
    }*/

    //console.log('DrDoc.SetViewDataset: view/list-dataset-width: ', DrDoc.configDevice.get('view/list-dataset-width'));

    if (false && DrDocWeb.IsMobile()) {
        DrDoc.configDevice.set('view/layout-mode', 'v');
        DrDoc.configDevice.set('view/list-dataset-mode', 'v');

        DrDoc.configDevice.set('view/list-sort-width', 0);
        DrDoc.configDevice.set('view/list-dataset-width', 0);
    }
    else {
        //if (DrDoc.configDevice.get('view/list-dataset-width') > 95 || DrDoc.configDevice.get('view/list-dataset-width') < 5)
        if (DrDoc.configDevice.get('view/list-dataset-width') > 70) {
            DrDoc.configDevice.set('view/list-dataset-width', 40);
        }
    }

    if (!DrDocWeb.IsNullOrEmpty(archiveName)) {
        DrDoc.configDevice.set('view/selected-archive', archiveName);
    }
};
DrDoc.SetViewList = async function (archiveName) {
    if (DrDoc._setViewInit == undefined)
        DrDoc.SetViewInit();

    console.log('DrDoc.SetViewList');
    //console.log('DrDoc.SetViewList: view/list-dataset-width: ', DrDoc.configDevice.get('view/list-dataset-width'));

    //if (DrDoc.configDevice.get('view/list-dataset-width') > 1 && DrDoc.configDevice.get('view/list-dataset-width') < 10)
    if (!DrDoc.configDevice.get('view/list-dataset-width') || DrDoc.configDevice.get('view/list-dataset-width') < 10) {
        DrDoc.configDevice.set('view/list-dataset-width', 50);
    }

    // Layout automatisch setzen je nach endgerät
    if (false && DrDocWeb.IsMobile()) {
        DrDoc.configDevice.set('view/layout-mode', 'v');
        DrDoc.configDevice.set('view/list-dataset-mode', 'v');

        DrDoc.HideSplitPanel();
    }

    DrDoc.UpdateViewMode();

    if (!DrDocWeb.IsNullOrEmpty(archiveName)) {
        DrDoc.configDevice.set('view/selected-archive', archiveName);
    }
};

DrDoc.SetViewInit = async function () {

    if (DrDoc._setViewInit == undefined) {
        console.log('DrDoc.SetViewInit (1) Initial');
        DrDoc._setViewInit = true;

        DrDoc.configDevice.subscribe('view/list-sort-mode', function (value) {
            //console.log('DatasetListContaionerWebNode 2 - sort mode - {{$_this.NamePath}}');
            DrDoc.configDevice.update('view/list-sort-width');
        }, 'h');

        DrDoc.configDevice.subscribe('view/list-dataset-mode', function (value) {
            //console.log('DatasetListContaionerWebNode 2 - dataset mode - {{$_this.NamePath}}');
            DrDoc.configDevice.update('view/list-dataset-width');
        }, 'v');

        setTimeout(DrDoc.UpdateViewMode, 500);
    }
    else {
        //console.log('DrDoc.SetViewInit (2)');
    }

    DrDoc.configDevice.update('view/layout-sm');
    DrDoc.configDevice.update('view/selected-archive');

    DrDoc.configUser.Write = false;
    DrDoc.configUser.update('view/label-style-classes');
    DrDoc.configUser.update('view/button-style-classes');
    DrDoc.configUser.update('view/read-only-style-classes');
    DrDoc.configUser.Write = true;
};

DrDoc.UpdateViewMode = async function () {
    //console.log('DrDoc.UpdateView');

    DrDoc.configDevice.update('view/list-sort-mode');
    DrDoc.configDevice.update('view/list-dataset-mode');
    DrDoc.configDevice.update('view/list/tree/cols');
};

DrDoc.DisplayDataseListTreeCols = function (cols) {
    //let tree = document.querySelector('.dataset-list .dataset-list-tree-container > .row');
    let treeElementList = document.querySelectorAll('.dataset-list-tree-container');
    //console.log('SetViewInit 1: ', tree, tree.children);
    //console.log('DrDoc.DisplayDataseListTreeCols: ', treeElementList);
    for (var tree of treeElementList) {
        if (tree != null) {
            tree.classList.remove('flex-nowrap');
            tree.classList.remove('flex-wrap');
            tree.classList.remove('card');
            if (cols)
                tree.classList.add('flex-nowrap');
            else
                tree.classList.add('flex-wrap');

            if (tree.children) {
                for (var cn of tree.children) {
                    cn.className = cols ? 'col-sm-12 col-md-6 col-lg-6 col-xxl-6 me-3 tree-item card' : 'col-12 tree-item';
                    cn.style.width = cols ? '' : '100%';
                }
            }
        }
    }
};
DrDoc.getOnChangeStyleFn = function (searchElemSelector) {
    return function (value, oldValue) {
        // console.log('DrDoc.getOnChangeStyleFn', this);
        var elemRoot = null;
        if (elemRoot == null || elemRoot == undefined)
            elemRoot = null;
        if (elemRoot == null || elemRoot == undefined)
            elemRoot = document;
        elemRoot.querySelectorAll(searchElemSelector).forEach(function (elem) {
            // alte Classes suchen und aus Elementen entfernen
            if (!DrDocWeb.IsNullOrEmpty(oldValue)) {
                for (let className of oldValue.split(' ')) {
                    if (DrDocWeb.IsNullOrEmpty(className))
                        continue;
                    elem.classList.remove(className);
                }
            }
            // neue Classes an Elemente anfügen
            if (!DrDocWeb.IsNullOrEmpty(value)) {
                for (let className of value.split(' ')) {
                    if (DrDocWeb.IsNullOrEmpty(className))
                        continue;
                    elem.classList.add(className);
                }
            }
        });
    };
};

// --

DrDoc.PageSetName = function (oldName, newName) {
    return DrDocWeb.Send('GET', '/config',
        {
            mode: 'page-set-name',
            name: oldName,
            value: newName
        });
};

DrDoc.PageSetUser = function (oldName, newName) {
    return DrDocWeb.Send('GET', '/config',
        {
            mode: 'page-set-user',
            name: oldName,
            value: newName
        });
};

DrDoc.PageAdd = function (name) {
    return DrDocWeb.Send('GET', '/config',
        {
            mode: 'page-add',
            preset: 'PAGE',
            name: name
        });
};

DrDoc.PageDelete = function (name) {
    return DrDocWeb.Send('GET', '/config',
        {
            mode: 'page-delete',
            name: name,
        });
};

// --

DrDoc.UserActionObj = function (action, obj) {
    if (obj == undefined)
        obj = {};
    obj.action = action;
    return DrDocWeb.Send('GET', '/user', obj, undefined, 'json', '', '', true).then((data) => {
        console.log('UserAction: ', action, obj);
        DrDocWeb.ModalInfo('UserAction: ' + action, data.Result + '\r\n<br>\r\n<br>' + DrDocWeb.ObjectToQueryStr(obj));
    });
};

DrDoc.CreateDatasetObj = function (archiveName, value) {
    let getObj = {};
    getObj.archive = archiveName;
    getObj.action = 'add';
    getObj.value = value;

    const getDataUrl = '/model/crud';
    return DrDocWeb.Send('GET', '/model/crud', getObj, undefined, 'json', '', '', true);
};

DrDoc.ConfigDeleteDatasetObj = function (archiveName, value) {
    let getObj = {};
    getObj.archive = archiveName;
    getObj.action = 'delete-all';
    getObj.value = value;
    getObj.usermanager = 'Config.BVD';

    const getDataUrl = '/model/crud';
    return DrDocWeb.Send('GET', '/model/crud', getObj, undefined, 'json', '', '', true);
};

DrDoc.SaveWebNode = function (nodeId, properties) {
    return DrDocWeb.Send('PUT', '/node/' + nodeId, {}, properties);
};

// --

// Menu Main

DrDoc.toggleMainMenuExpansion = function () {
    if (DrDoc.updateMainMenuExpansion())
        DrDoc.updateMainMenuExpansion(true);
    else
        DrDoc.updateMainMenuExpansion(false);

    //var elem = document.getElementById('menu-main-drdoc');
    //DrDoc.updateMainMenuExpansion();

    /*
    // Toggle: Hauptmenü links ein-/ausklappen
    if (elem.classList.contains('expanded'))
    {
        elem.classList.remove('expanded');
    }
    else
    {
        elem.classList.add('expanded');
    }
    */

    /*
    // Toggle: Hauptmenü links vollständig ein-/ausblenden
    if (elem.classList.contains('d-none'))
    {
        elem.classList.remove('d-none');
    }
    else
    {
        elem.classList.add('d-none');
    }*/
};

DrDoc.updateMainMenuExpansion = function (hide) {
    if (!document.querySelector('#menu-main-drdoc'))
        return;
    document.querySelector('#menu-main-drdoc-container').classList.remove('d-none');

    // Ausklappen, wenn noch ausgeklappte Menüs vorhanden sind
    let openMenuItems = document.querySelectorAll('#menu-main-drdoc button[aria-expanded]');
    let openMenuItemsExpanded = document.querySelectorAll('#menu-main-drdoc button[aria-expanded="true"]');
    // if ((DrDocWeb.IsMobile() && window.innerWidth > 800) || (!DrDocWeb.IsMobile() && openMenuItems != null && openMenuItems.length > 0))
    if (hide === true) {
        //console.log('DrDoc.updateMainMenuExpansion: CLOSE');
        document.querySelector('#menu-main-drdoc').classList.remove('expanded');
        if (document.querySelector('#menu-main-top'))
            document.querySelector('#menu-main-top').classList.remove('expanded');
        if (openMenuItems != null) {
            openMenuItems.forEach(function (openMenuItem) {
                //bootstrap.Collapse.getOrCreateInstance(openMenuItem).hide();

                //bootstrap.Collapse.getOrCreateInstance(openMenuItem).toggle();
                /*openMenuItem.classList.remove('show');
                openMenuItem.classList.remove('open');*/
                openMenuItem.setAttribute('aria-expanded', 'false');
                openMenuItem.classList.remove('expanded');
            });
        }
        openMenuItems = document.querySelectorAll('#menu-main-drdoc .show');
        if (openMenuItems != null) {
            openMenuItems.forEach(function (openMenuItem) {
                openMenuItem.classList.remove('show');
            });
        }
        return false;
    }
    else if (hide === false) {
        //console.log('DrDoc.updateMainMenuExpansion: OPEN');
        document.querySelector('#menu-main-drdoc').classList.add('expanded');
        if (document.querySelector('#menu-main-top'))
            document.querySelector('#menu-main-top').classList.add('expanded');
        if (openMenuItems != null) {
            openMenuItems.forEach(function (openMenuItem) {
                //bootstrap.Collapse.getOrCreateInstance(openMenuItem).open();

                //bootstrap.Collapse.getOrCreateInstance(openMenuItem).toggle();
                /*openMenuItem.classList.add('show');
                openMenuItem.classList.add('open');*/
                openMenuItem.setAttribute('aria-expanded', 'true');
                openMenuItem.classList.add('expanded');
            });
        }
        /*openMenuItems = document.querySelectorAll('#menu-main-drdoc .show');
        if (openMenuItems != null)
        {
            openMenuItems.forEach(function(openMenuItem) {
                openMenuItem.classList.remove('show');
            });
        }*/
        return true;
    }

    //if (!DrDocWeb.IsMobile() && openMenuItems != null && openMenuItems.length > 0)
    if (openMenuItemsExpanded != null && openMenuItemsExpanded.length > 0) {
        //console.log('DrDoc.updateMainMenuExpansion: UPDATE - is OPEN');
        document.querySelector('#menu-main-drdoc').classList.add('expanded');
        if (document.querySelector('#menu-main-top'))
            document.querySelector('#menu-main-top').classList.add('expanded');
        return true;
    }
    else {
        //console.log('DrDoc.updateMainMenuExpansion: UPDATE - is CLOSED');
        document.querySelector('#menu-main-drdoc').classList.remove('expanded');
        if (document.querySelector('#menu-main-top'))
            document.querySelector('#menu-main-top').classList.remove('expanded');
        return false;
    }
};

//// ---------------------------------


DrDoc.Init = async function () {
    if (window.DrDoc !== undefined) {
        console.warn("Dr.DOC RE-INIT");
        return window.DrDoc;
    }
    window.DrDoc = DrDoc;
    console.log('Dr.DOC Init() START');

    Store._debug = false;

    DrDoc.store = new Store();
    DrDoc.configUser = new DrDocConfig(DrDoc.store, false);
    DrDoc.configUser.readonly = true;
    DrDoc.configDevice = new DrDocConfig(DrDoc.store, true);
    DrDoc.configUser.readonly = false;

    //console.log('DrDoc.store initialized');

    DrDoc.store.init('userdata', function () {
        let userdata = DrDocWeb.SendGet('/user', { action: 'status' }, 'json');
        DrDoc.store.set('userdata', userdata);
        //DrDoc.TestUser()
        return userdata;
    }).then(function () {
        //console.log('userdata subscribe _sub1 then ok');

        // --

        // wenn "view/selected-archive" nicht gefunden werden kann, dann das erstes verfügbares Archiv wählen.
        DrDoc.store.subscribe('userdata', function (data) {
            if (data && data.Count > 0) {
                DrDoc.configUser.readonly = false;
            }
            console.log('DrDoc.store.subscribe: ', data);
            let selectedArchive = DrDoc.configDevice.get('view/selected-archive');
            if (DrDoc.GetArchive(selectedArchive) == null) {
                if (data != undefined && data.Result != undefined && data.Result.Archives != undefined &&
                    data.Result.Archives && data.Result.Archives.length > 0) {
                    //console.log('Selected Archive (configDevice) NOT found: ', selectedArchive, ' - selecting: ', data.Result.Archives[0].Archive.SimpleName);
                    DrDoc.configDevice.set('view/selected-archive', data.Result.Archives[0].Archive.SimpleName);
                }
                else {
                    //console.log('Selected Archive (configDevice) NOT found: Noch Archive found.');
                }
            }
            else {
                //console.log('Selected Archive (configDevice) found: ', selectedArchive);
            }
        });


        // --
        // Subscribe

        DrDoc.configUser.subscribe('view/selected-usermanager', function (value, oldValue) {
            // User Daten neu laden
            //DrDoc.store.update('userdata');
            //DrDoc.SearchInbox(document.documentElement);
            console.log('Usermanager has changed: ', value, ' <- ', oldValue);
            if (!DrDocWeb.IsNullOrEmpty(oldValue)) {
                setTimeout(function () {
                    window.location.reload();
                }, 1500);
            }
        });

        // Sortierung anzeigen/ausblenden
        DrDoc.configUser.subscribeBool('view/list/show-tree', function (value, oldValue) {
            if (value) {
                if (DrDoc.configDevice.get('view/list-sort-width') <= 1) {
                    DrDoc.configDevice.set('view/list-sort-width', 15);
                }
            }
            else {
                // Tree ausblenden
                DrDoc.configDevice.set('view/list-sort-width', 2);
                DrDoc.configDevice.set('view/list-sort-width', 0);
            }
        }, false);

        DrDoc.configDevice.subscribeBool('view/list/tree/cols', function (value, oldValue) {
            DrDoc.DisplayDataseListTreeCols(value);
        }, false);


        DrDoc.configDevice.subscribeBool('view/layout-sm', function (value) {
            // 'table-sm', 

            let selectorClasses = ['btn-sm', 'btn-group-sm', 'btn-toolbar-sm', 'input-group-sm', 'form-select-sm', 'form-control-sm', 'pagination-sm', 'table-sm'];
            selectorClasses.forEach(function (selector) {
                // $('.btn .btn-sm').addClass();
                if (value === true) {
                    // *-sm Klassen hinzufügen
                    document.querySelectorAll('.dd-' + selector).forEach(function (elem) {
                        elem.classList.add(selector);
                        elem.classList.remove('dd-' + selector);
                    });
                    document.querySelectorAll(selector).forEach(function (elem) {
                        elem.classList.remove('dd-' + selector);
                    });
                }
                else { //if (value === false) {
                    document.querySelectorAll('.' + selector).forEach(function (elem) {
                        elem.classList.add('dd-' + selector);
                        elem.classList.remove(selector);
                    });
                    document.querySelectorAll('.dd-' + selector).forEach(function (elem) {
                        elem.classList.remove(selector);
                    });
                }
                /*else {
                    console.warn('dafuq Value.. ', value);
                }*/
            });
        }, true);

        DrDoc.configUser.subscribe('view/label-style-classes', DrDoc.getOnChangeStyleFn('.dd-label-style-classes'));
        DrDoc.configUser.subscribe('view/button-style-classes', DrDoc.getOnChangeStyleFn('.dd-button-style-classes'));
        DrDoc.configUser.subscribe('view/read-only-style-classes', DrDoc.getOnChangeStyleFn('.dd-read-only-style-classes'));


        DrDoc._navLastArchive = '';
        DrDoc.configDevice.subscribe('view/selected-archive', function (value) {
            if (value == undefined || value == null)
                return;
            console.log('Archive has changed: ', value);

            if (DrDoc._navLastArchive != value) {
                DrDoc._navLastArchive = value;
                console.log('DrDoc.historyAddPage: Archive has changed: ', value);
                window.history.pushState({ action: 'change-archive', value: value }, window.location.href, window.location.href);
            }

            // Liste als Ansicht wählen
            //DrDoc.SetViewList();
            DrDoc.UpdateViewMode();
        }, '__none__');


        DrDoc.configUser.subscribeBool('view/list/show-tree-list-group', function (value) {
            if (value === true) // && DrDoc.configUser.get('view/list/show-tree') === true)
            {
                DrDoc.configUser.set('view/list/show-tree', false);
                //console.log('DrDoc.configUser.set(view/list/show-tree, false);');
            }
        }, false);
        DrDoc.configUser.subscribeBool('view/list/show-tree', function (value) {
            if (value === true) // && DrDoc.configUser.get('view/list/show-tree-list-group') === true)
            {
                DrDoc.configUser.set('view/list/show-tree-list-group', false);
                //console.log('DrDoc.configUser.set(view/list/show-tree-list-group, false);');
            }
        }, false);

        /*
        DrDoc.configUser.subscribeBool('view/menu-system/mask-show', function(value) {
            let elem = document.querySelector('#collapseToolbarMask');
            if (value)
                elem.addClass('show');
            else
                elem.removeClass('show');
        });
         
        DrDoc.configUser.subscribeBool('view/menu-system/mask-list', function(value) {
            let elem = document.querySelector('#collapseToolbarList');
            if (value)
                elem.addClass('show');
            else
                elem.removeClass('show');
        });
        */

    }).catch(function (err) {
        // abbrechen, wenn 'userdata' fehlschlägt
        console.log('userdata subscribe _sub1 failed', err);
        //DrDoc.configUser.clear();
    });
    // init('userdata') Ende

    //window.removeEventListener('popstate', Node.OnNavigateComponentEvent);
    window.addEventListener('popstate', function (e) {
        if (e.state != undefined && e.state != null && e.state.action == 'change-archive') {
            e.preventDefault();
            console.warn('DrDoc.historyAddPage: change Archive: ', e.state.value);
            //console.warn('DrDoc.historyAddPage: set archive: ', e.state.value);
            DrDoc.configDevice.set('view/selected-archive', e.state.value);
        }
    });


    document.addEventListener('NodeUnloaded', function (e) {
        //console.log("NodeUnloaded");

        document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (triggerElem) {
            let bs_elem = bootstrap.Tooltip.getInstance(triggerElem);
            if (bs_elem)
                bs_elem.dispose();
        });
        document.querySelectorAll('.tooltip.bs-tooltip-auto').forEach(function (triggerElem) {
            triggerElem.remove();
        });
        /*document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(function (triggerElem) {
            let bs_elem = bootstrap.Dropdown.getInstance(triggerElem);
            if (bs_elem)
                bs_elem.dispose();
        });
        document.querySelectorAll('[data-bs-toggle="collapse"]').forEach(function (triggerElem) {
            let bs_elem = bootstrap.Collapse.getInstance(triggerElem);
            if (bs_elem)
                bs_elem.dispose();
        });*/
    });

    //window.addEventListener('dragover', null);
    //window.addEventListener('drop', null);
    //document.addEventListener('dragover', null);
    //document.addEventListener('drop', null);

    // Initialisierung
    document.addEventListener('NodeLoaded', function (e) {
        //console.log("NodeLoaded 123");

        DrDoc.SetViewInit();
        //DrDoc.UpdateSplitPanel();

        //document.querySelector('.selected-archive').val(value);


        //document.querySelectorAll('[bind-conf-user]').forEach(DrDoc.configUser.BindConfig.bind(DrDoc.configUser));
        //document.querySelectorAll('[bind-conf-dev]').forEach(DrDoc.configDevice.BindConfig.bind(DrDoc.configDevice));

        /*document.querySelectorAll('[ondragover]').forEach(function (elem) {
            elem.setAttribute('draggable', 'true');
            elem.setAttribute('droppable', 'true');
            //if (elem.ondrop === undefined)
            //    elem.ondrop = function (ev) { };
    
            elem.addEventListener('dragover', function(ev)
            {
                console.log('dragover TEST');
              ev.preventDefault(); // Necessary. Allows us to drop.    
              ev.currentTarget.setAttribute('style', "border-top:solid;");   
            });
    
            //console.log('Drag/Drop: ', elem);
        });*/

        document.querySelectorAll('[bind-conf-user]').forEach(function (elem) {
            DrDoc.configUser.BindConfig(elem, 'bind-conf-user');
        });
        document.querySelectorAll('[bind-conf-dev]').forEach(function (elem) {
            DrDoc.configDevice.BindConfig(elem, 'bind-conf-dev');
        });


        /*var treeToggler = document.getElementsByClassName("tree-caret");
        if (treeToggler != undefined && treeToggler != null)
        {
            let updateTreeElem = function(elem) {
                if (elem.parentElement.querySelector(".tree-nested").classList.contains('tree-active'))
                    elem.classList.add("tree-caret-down");
                else
                    elem.classList.remove("tree-caret-down");
            }
            for (let i = 0; i < treeToggler.length; i++) {
                updateTreeElem(treeToggler[i]);
                treeToggler[i].addEventListener("click", function(e) {
                    e.target.parentElement.querySelector(".tree-nested").classList.toggle("tree-active");
                    updateTreeElem(e.target);
                });
            }
        }*/

        // Tree View
        DrDocWeb.TreeView();


        //window.addEventListener("beforeunload", function() {
        //    return "Are you sure? You didn't finish the form!";
        //});

        // Drag n Drop
        DrDocWeb.dnd_init(document);

        document.querySelectorAll('[data-bs-toggle="tab"]').forEach(function (triggerElem) {
            let target = triggerElem.getAttribute('data-bs-target');
            if (!DrDocWeb.IsNullOrEmpty(target)) {
                const bs_elem = bootstrap.Tab.getOrCreateInstance(triggerElem);
            }
        });
        document.querySelectorAll('[data-bs-toggle="pill"]').forEach(function (triggerElem) {
            let target = triggerElem.getAttribute('data-bs-target');
            if (!DrDocWeb.IsNullOrEmpty(target)) {
                const bs_elem = bootstrap.Tab.getOrCreateInstance(triggerElem);
            }
        });

        document.querySelectorAll('[data-bs-toggle="popover"]').forEach(function (triggerElem) {
            let title = triggerElem.getAttribute('data-bs-content');
            if (!DrDocWeb.IsNullOrEmpty(title)) {
                const bs_elem = bootstrap.Popover.getOrCreateInstance(triggerElem);
            }
            //bs_elem.update();
        });

        document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (triggerElem) {
            let title = triggerElem.getAttribute('data-bs-title');
            if (!DrDocWeb.IsNullOrEmpty(title)) {
                const bs_elem = bootstrap.Tooltip.getOrCreateInstance(triggerElem);
            }
            //bs_elem.update();
        });

        // --


        document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(function (triggerElem) {
            if (triggerElem._hasHandlerX === true)
                return;
            triggerElem._hasHandlerX = true;

            let dropdown = triggerElem.parentNode;
            let dropdownMenu = null;

            let triggerElemSelector = triggerElem.getAttribute('data-bs-target');
            if (!DrDocWeb.IsNullOrEmpty(triggerElemSelector)) {
                dropdownMenu = document.querySelector(triggerElemSelector);
            }

            if (dropdownMenu == undefined || dropdownMenu == null) {
                dropdownMenu = dropdown.querySelector('.dropdown-menu');
                //console.log('BS Dropdown Init: Get Target Elem ', triggerElem, ' => ', dropdownMenu, ' / ', triggerElem.parentNode);
            }

            let bsDropdown = bootstrap.Dropdown.getOrCreateInstance(triggerElem);

            triggerElem.addEventListener('click', function () {

                //dropdown.classList.add('position-static');

                if (triggerElem._popper != undefined)
                    triggerElem._popper.destroy();

                // noch nicht angezeigt? => anzeigen
                if (dropdownMenu.classList.contains('show')) {
                    dropdown.classList.remove('show');
                    dropdownMenu.classList.remove('show');
                    triggerElem.setAttribute('aria-expanded', false);
                }
                else {
                    let popperTmp = window.createPopper(dropdown, dropdownMenu, {
                        placement: 'bottom-end',
                        modifiers: {
                            offset: 0,
                            flip: {
                                enabled: true,
                            },
                            preventOverflow: {
                                boundariesElement: 'viewport',
                            },
                        },
                    });

                    bsDropdown._popper = popperTmp;
                    triggerElem._popper = popperTmp;

                    triggerElem.focus();
                    triggerElem.setAttribute('aria-expanded', true);

                    dropdown.classList.add('show');
                    dropdownMenu.classList.add('show');

                    //console.log('BS Dropdown Click: ', triggerElem, ' => ', dropdownMenu, ' / BS: ', triggerElem._popper);
                }
            });

            /*
            const bs_elem = bootstrap.Dropdown.getOrCreateInstance(triggerElem);
            bs_elem._popper = window.createPopper;
            bs_elem.update();
            bs_elem.show();
            console.log('BS Dropdown Init: ', bs_elem);
            */

            //DrDocWeb.BS_DropdownInit(triggerElem);
        });

        // Dropdowns beim Click nicht automatisch schließen
        // .dropdown-menu 
        // .dropdown-leave-open > .dropdown-item
        if (document.querySelectorAll('.dropdown-leave-open > li > a.dropdown-item'))
            document.querySelectorAll('.dropdown-leave-open > li > a.dropdown-item').forEach(function (elem) {
                elem.addEventListener("click", function (e) {
                    e.stopPropagation();
                    //console.log('click!');
                });
            });

        // --

        // Menu Main


        // Die Klasse "expanded" dem Element "#menu-main-drdoc" hinzufügen
        DrDoc.updateMainMenuExpansion();

        // --

        // Collapese Zustand aus Config laden/merken
        document.querySelectorAll('[data-bs-toggle="collapse"]').forEach(function (triggerElem) {
            if (triggerElem._hasCollapseHandler === true)
                return;
            triggerElem._hasCollapseHandler = true;

            let triggerElemExpandedValue = triggerElem.getAttribute('aria-expanded');
            let triggerElemExpanded = DrDocWeb.IsNullOrEmpty(triggerElemExpandedValue) ? null : (triggerElemExpandedValue == 'true');
            let triggerElemSelector = triggerElem.getAttribute('data-bs-target');
            let targetElemArr = document.querySelectorAll(triggerElemSelector);

            if (targetElemArr == null)
                return;

            if (targetElemArr.length > 1) {
                console.log('more then one target: [data-bs-toggle="collapse"]: ', targetElemArr.length, ' / ', targetElemArr);
            }
            let targetElem = targetElemArr[0];

            //targetElemArr.forEach(function (targetElem) {

            if (targetElem == null)
                return;
            const bs_elem = bootstrap.Collapse.getOrCreateInstance(targetElem, { toggle: false });

            // Attribute [aria-expanded] undefined?
            // Init State from Config
            if (!DrDocWeb.IsNullOrEmpty(triggerElemSelector) && targetElem != undefined && targetElem != null) {
                let confName = 'view/collapse-menu/' + triggerElemSelector.substring(1);

                // on Show
                targetElem.addEventListener('show.bs.collapse', function (e) {
                    //console.log('show.bs.collapse: ', targetElem, confName);
                    DrDoc.configDevice.set(confName, true);
                    DrDoc.updateMainMenuExpansion();
                });

                // on Hide
                targetElem.addEventListener('hide.bs.collapse', function (e) {
                    //console.log('hide.bs.collapse: ', targetElem, confName);
                    DrDoc.configDevice.set(confName, false);
                    DrDoc.updateMainMenuExpansion();
                });

                // Menü links einklappen/ausklappen
                targetElem.addEventListener('shown.bs.collapse', function (e) {
                    //console.log('shown.bs.collapse: ', targetElem);
                    //DrDoc.configDevice.set(confName, true);
                    DrDoc.updateMainMenuExpansion();
                });
                targetElem.addEventListener('hidden.bs.collapse', function (e) {
                    //console.log('hidden.bs.collapse: ', targetElem);
                    //DrDoc.configDevice.set(confName, false);
                    DrDoc.updateMainMenuExpansion();
                });

                if (triggerElemExpanded == null) {
                    console.log('init.bs.collapse: ', triggerElem, confName);
                    DrDoc.configDevice.subscribeBool(confName, function (valueNew, valueOld) {
                        const bs_elem2 = bootstrap.Collapse.getOrCreateInstance(targetElem);
                        if (valueNew === true) // && targetElem != null && !targetElem.classList.contains('show'))
                        {
                            //console.log('init.bs.collapse SHOW: onChange: ', confName, valueNew, valueOld);
                            bs_elem2.show();
                        }
                        if (valueNew === false) // && targetElem != null && targetElem.classList.contains('show'))
                        {
                            //console.log('init.bs.collapse HIDE: onChange: ', confName, valueNew, valueOld);
                            bs_elem2.hide();
                        }
                    }, false);
                }
            }

            // Element inital einklappen / ausklappen
            if (triggerElemExpanded === true) {
                //console.log('init.bs.collapse: aria-expanded=true SHOW: ', targetElem, triggerElem, confName);
                bs_elem.show();
            }
            else if (triggerElemExpanded === false) {
                //console.log('init.bs.collapse: aria-expanded=false HIDE: ', targetElem, triggerElem, confName);
                bs_elem.hide();
            }

            //});
        });

        // --

        // es können keine Attribute ohne Wert mit Expressions gesetzt werden.
        // für required, readonly, checked kann data-* verwendet werden


        // Allen Pflichtfeldern die Klasse "is-required-empty" hinzufügen
        function initMandatoryFields(e) {
            //console.log('mandatory field changed ', e, this);
            let elems = e.target; //$('[data-required="true"]');
            tmpval = elems.value;
            if (DrDocWeb.IsNullOrEmpty(tmpval)) {
                elems.classList.add('is-required-empty');
                elems.classList.remove('is-required-not-empty');
            } else {
                elems.classList.add('is-required-not-empty');
                elems.classList.remove('is-required-empty');
            }
        };

        document.querySelectorAll('[data-required]').forEach(function (elem) {
            elem.removeAttribute('required');
        });
        document.querySelectorAll('[data-required="true"]').forEach(function (elem) {
            elem.setAttribute('required', true);
            elem.addEventListener('change', initMandatoryFields);
            initMandatoryFields({ target: elem });
        });

        let boolAttrs = ['readonly', 'checked', 'selected'];
        for (let attrName of boolAttrs) {
            if (!document.querySelectorAll('[data-' + attrName + ']'))
                continue;
            document.querySelectorAll('[data-' + attrName + ']').forEach(function (elem) {
                elem.removeAttribute(attrName);
            });
            var setCheckElem = function (elem, attrName, checked) {
                elem.setAttribute('data-' + attrName, checked);
                if (checked)
                    elem.setAttribute(attrName, true);
                else
                    elem.removeAttribute(attrName);
            };
            document.querySelectorAll('[data-' + attrName + '="false"]').forEach(function (elem) {
                setCheckElem(elem, attrName, false);
                elem.addEventListener('change', function (e) {
                    setCheckElem(e.target, attrName, e.target.checked);
                });
            });
            document.querySelectorAll('[data-' + attrName + '="true"]').forEach(function (elem) {
                setCheckElem(elem, attrName, true);
                elem.addEventListener('change', function (e) {
                    setCheckElem(e.target, attrName, e.target.checked);
                });
            });
        }

        if (document.querySelector('[required] [data-selected]')) {
            document.querySelectorAll('[required] [data-selected]').forEach(function (optionElem) {
                //document.querySelector(optionElem.parentNode).on('change', initMandatoryFields);
                //document.querySelector(optionElem.parentNode).each(initMandatoryFields);
                initMandatoryFields({ target: optionElem });
            });
        }

        // --

        /*
        // Toggle Control automatisch öffnen/schließen je nach Endgerät
        $('.ds-nav').each(function(i) {
            let bsCollapse = bootstrap.Collapse.getInstance(this);
     
            // falls bereits eine Instanz exisitert, überspringen
            if (bsCollapse !== undefined && bsCollapse !== null)
                return;
     
            bsCollapse = new bootstrap.Collapse(this, {
              toggle: false
            });
     
            //console.log('toggler', bsCollapse, DrDocWeb.IsMobile());
     
            //if (DrDocWeb.IsMobile())
            //    bsCollapse.hide();
            //else
                bsCollapse.show();
        });
     
        // --
        */

        let onLoadDoc = function (e) {
            if (window.DrDoc == undefined)
                return;

            console.log('Dr.DOC Init(): onLoadDocument');

            DrDoc.SetViewInit();

            DrDocWeb.TreeView();

            //window.addEventListener('resize', DrDoc.SetViewInit);

            window.addEventListener('beforeunload', DrDoc.CloseAllDocumentWnd);

            //DrDoc.UpdateViewMode();
            // SetViewList() ruft intern UpdateView() auf
            //DrDoc.SetViewList();
            //setTimeout(DrDoc.SetViewInit, 500);

            DrDocWeb.TreeView();
        };

        if (document.readyState === "loading") {
            //console.log('document.readyState === "loading"');
            document.addEventListener('DOMContentLoaded', onLoadDoc);
        }
        else {
            //console.log('onLoadDoc()');
            onLoadDoc();
        }

    });
    // NodeLoaded Ende

    console.log('Dr.DOC Init() END');
};

DrDoc.Init();
